<template>
  <div>
    <!-- 功能导航 -->
    <div class="function-nav">
      <div class="nav-tabs">
        <span class="tab" :class="{ active: activeTab === 'dormitory' }" @click="switchTab('dormitory')">宿舍人员管理</span>
        <span class="tab" :class="{ active: activeTab === 'bed' }" @click="switchTab('bed')">床位管理</span>
        <span class="tab" :class="{ active: activeTab === 'building' }" @click="switchTab('building')">楼宇管理</span>
        <span class="tab" :class="{ active: activeTab === 'room' }" @click="switchTab('room')">房间管理</span>
        <span class="tab" :class="{ active: activeTab === 'device' }" @click="switchTab('device')">设备管理</span>
        <span class="tab" :class="{ active: activeTab === 'manager' }" @click="switchTab('manager')">宿管管理</span>
        <span class="tab" :class="{ active: activeTab === 'inout' }" @click="switchTab('inout')">出入管理</span>
      </div>
      <div class="refresh-btn" @click="refreshData">
        <img src="images/alram/e2a3cbe1ebfd6d188b1927e610af0e25.png" />
        <span>刷新</span>
      </div>
    </div>

    <!-- 宿舍人员管理内容 -->
    <div v-if="activeTab === 'dormitory'">
      <!-- 搜索区域 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields" style="display: flex; flex-wrap: wrap; align-items: center;">
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿舍楼：</label>
              <select class="form-input" v-model="searchForm.dormitory_name" style="flex: 1;min-width: 240px;">
                <option value="">全部</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">房间号：</label>
              <input class="form-input" v-model="searchForm.room_number" style="flex: 1;min-width: 240px;" placeholder="请输入房间号" />
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">姓名：</label>
              <input class="form-input" v-model="searchForm.name" style="flex: 1;min-width: 240px;" placeholder="请输入姓名" />
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">工作单位：</label>
              <input class="form-input" v-model="searchForm.department" style="flex: 1;min-width: 240px;" placeholder="请输入工作单位" />
            </div>
          </div>

          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchData">
              搜索
            </button>
            <button type="button" class="search-btn-green" @click="printDormitoryData">
              导出
            </button>
          </div>
        </form>
      </div>

      <!-- 新增按钮 -->
      <div style="margin: 0 0 16px 8px;">
        <button class="search-btn-green" @click="showAddModal">新增人员</button>
      </div>

      <!-- 数据表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>人员编号</th>
                <th>姓名</th>
                <th>工作单位</th>
                <th>身份证号码</th>
                <th>性别</th>
                <th>宿舍楼</th>
                <th>房间号</th>
                <th>床位号</th>
                <th>联系方式</th>
                <th>照片</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in pagedData" :key="item.id || idx">
                <td>{{ item.id || '-' }}</td>
                <td>{{ item.name }}</td>
                <td>{{ item.department || '-' }}</td>
                <td>{{ item.id_card }}</td>
                <td>{{ item.gender || '-' }}</td>
                <td>{{ item.room_info?.dormitory_name || '-' }}</td>
                <td>{{ item.room_info?.room_number || '-' }}</td>
                <td>{{ item.room_info?.bed_number || '-' }}</td>
                <td>{{ item.contact || '-' }}</td>
                <td>
                  <el-image style="width: 20px; height: 20px" :src="item.face_url" :preview-src-list="[item.face_url]" v-if="item.face_url != ''"></el-image>
                  <span v-else>----</span>
                </td>
                <td>
                  <span :class="item.access_type === 'in' ? 'status-in' : 'status-out'">
                    {{ item.access_type === 'in' ? '在寝' : '未归寝' }}
                  </span>
                </td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showEditModal(item)">
                      编辑
                    </button>
                    <button class="search-btn-green" style="padding:4px 8px; background: #f44336;" @click="deletePerson(item)">
                      删除
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="pagedData.length === 0">
                <td colspan="10" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="currentPage===1" @click="changePage(1)">«</button>
          <button class="page-btn" :disabled="currentPage===1" @click="changePage(currentPage - 1)">‹</button>
          <span v-for="p in displayPages" :key="p">
            <button class="page-btn" :class="{active:currentPage===p}" @click="changePage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="currentPage===totalPages" @click="changePage(currentPage + 1)">›</button>
          <button class="page-btn" :disabled="currentPage===totalPages" @click="changePage(totalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="pageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpPage">跳转</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 床位管理内容 -->
    <div v-if="activeTab === 'bed'">
      <!-- 搜索区域 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields" style="display: flex; gap: 140px; align-items: center;">
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿舍楼：</label>
              <select class="form-input" v-model="bedSearchForm.dormitory_name" style="flex: 1;">
                <option value="">全部</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">房间号：</label>
              <input class="form-input" v-model="bedSearchForm.room_number" style="flex: 1;" placeholder="请输入房间号" />
            </div>

          </div>

          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchBedData">
              查询
            </button>
            <button type="button" class="search-btn-green" @click="printBedData">
              打印
            </button>
          </div>
        </form>
      </div>

      <!-- 操作按钮 -->
      <div style="margin: 0 0 16px 8px; display: flex; gap: 12px;">
        <button class="search-btn-green" @click="showAddBedModal">新增床位</button>
      </div>

      <!-- 床位数据表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>宿舍楼</th>
                <th>房间号</th>
                <th>床位号</th>
                <th>状态</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in bedData" :key="item.id || idx">
                <td>{{ item.id || '-' }}</td>
                <td>{{ item.room_info?.dormitory_name || '-' }}</td>
                <td>{{ item.room_info?.room_number || '-'}}</td>
                <td>{{ item.bed_number || '-'}}</td>
                <td>
                  <span class="item.personnel_info ? 'status-occupied' : 'status-vacant'">
                    {{ item.personnel_info ? '已占用' : '空闲' }}
                  </span>
                </td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showEditBedModal(item)">
                      编辑
                    </button>
                    <button class="search-btn-green" style="padding:4px 8px; background: #f44336;" @click="deleteBed(item)">
                      删除
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="bedData.length === 0">
                <td colspan="6" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="bedCurrentPage===1" @click="changeBedPage(1)">«</button>
          <button class="page-btn" :disabled="bedCurrentPage===1" @click="changeBedPage(bedCurrentPage - 1)">‹</button>
          <span v-for="p in displayBedPages" :key="p">
            <button class="page-btn" :class="{active:bedCurrentPage===p}" @click="changeBedPage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="bedCurrentPage===bedTotalPages" @click="changeBedPage(bedCurrentPage + 1)">›</button>
          <button class="page-btn" :disabled="bedCurrentPage===bedTotalPages" @click="changeBedPage(bedTotalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="bedPageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpBedPage">跳转</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 楼宇管理内容 -->
    <div v-if="activeTab === 'building'">
      <!-- 搜索区域 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields" style="display: flex; gap: 140px; align-items: center;">
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿舍楼：</label>
              <select class="form-input" v-model="buildingSearchForm.building_name" style="flex: 1;">
                <option value="">全部</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <!-- <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">楼宇类型：</label>
              <select class="form-input" v-model="buildingSearchForm.building_type" style="flex: 1;">
                <option value="">全部</option>
                <option value="独栋楼">独栋楼</option>
                <option value="联排楼">联排楼</option>
                <option value="公寓楼">公寓楼</option>
              </select>
            </div> -->
          </div>

          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchBuildingData">
              查询
            </button>
            <button type="button" class="search-btn-green" @click="printBuildingData">
              打印
            </button>
          </div>
        </form>
      </div>

      <!-- 操作按钮 -->
      <div style="margin: 0 0 16px 8px; display: flex; gap: 12px;">
        <button class="search-btn-green" @click="showAddBuildingModal">新增</button>

      </div>

      <!-- 楼宇数据表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>楼宇名称</th>
                <!-- <th>单元数</th> -->
                <th>楼宇层数</th>
                <th>起始层</th>
                <!-- <th>房间数</th> -->
                <th>楼宇类型</th>
                <th>宿管</th>
                <th>更新时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in buildingData" :key="item.id || idx">
                <td>{{ item.id || '-' }}</td>
                <td>{{ item.building_name || '-' }}</td>
                <!-- <td>{{ item.unit_count || '-' }}</td> -->
                <td>{{ item.floors || '-' }}</td>
                <td>{{ item.start_floor || '-' }}</td>
                <!-- <td>{{ item.room_count || '-' }}</td> -->
                <td>{{ item.building_type || '-' }}</td>
                <td>{{ item.manager || '-' }}</td>
                <td>{{ item.update_time || '-' }}</td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showEditBuildingModal(item)">
                      编辑
                    </button>
                    <button class="search-btn-green" style="padding:4px 8px; background: #f44336;" @click="deleteBuilding(item)">
                      删除
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="buildingData.length === 0">
                <td colspan="10" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="buildingCurrentPage===1" @click="changeBuildingPage(1)">«</button>
          <button class="page-btn" :disabled="buildingCurrentPage===1" @click="changeBuildingPage(buildingCurrentPage - 1)">‹</button>
          <span v-for="p in displayBuildingPages" :key="p">
            <button class="page-btn" :class="{active:buildingCurrentPage===p}" @click="changeBuildingPage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="buildingCurrentPage===buildingTotalPages" @click="changeBuildingPage(buildingCurrentPage + 1)">›</button>
          <button class="page-btn" :disabled="buildingCurrentPage===buildingTotalPages" @click="changeBuildingPage(buildingTotalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="buildingPageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpBuildingPage">跳转</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 房间管理内容 -->
    <div v-if="activeTab === 'room'">
      <!-- 搜索区域 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields" style="display: flex; gap: 140px; align-items: center;">
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿舍楼：</label>

    
              <select class="form-input" v-model="roomSearchForm.dormitory_name" style="flex: 1;">
                <option value="">全部</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">房间号：</label>
              <input class="form-input" v-model="roomSearchForm.room_number" style="flex: 1;" placeholder="请输入房间号" />
            </div>
          </div>


          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchRoomData">
              查询
            </button>
            <button type="button" class="search-btn-green" @click="printRoomData">
              打印
            </button>
          </div>
        </form>
      </div>

      <!-- 操作按钮 -->
      <div style="margin: 0 0 16px 8px; display: flex; gap: 12px;">
        <button class="search-btn-green" @click="showAddRoomModal">新增</button>

      </div>

      <!-- 房间数据表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>房间号</th>
                <th>房间类型</th>
                <th>所属楼宇</th>
                <th>所属楼层</th>
                <th>入住数量/床位总数</th>
                <th>备注</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in roomData" :key="item.id || idx">
                <td>{{ item.id || '-' }}</td>
                <td>{{ item.room_number || '-' }}</td>
                <td>{{ item.room_type || '-' }}</td>
                <td>{{ item.dormitory_info?.dormitory_name || '-' }}</td>
                <td>{{ item.floor || '-' }}</td>
                <td>{{ item.current_occupancy }}/{{ item.capacity }}</td>
                <td>{{ item.remark || '/' }}</td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showEditRoomModal(item)">
                      编辑
                    </button>
                    <button class="search-btn-green" style="padding:4px 8px; background: #f44336;" @click="deleteRoom(item)">
                      删除
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="roomData.length === 0">
                <td colspan="8" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="roomCurrentPage===1" @click="changeRoomPage(1)">«</button>
          <button class="page-btn" :disabled="roomCurrentPage===1" @click="changeRoomPage(roomCurrentPage - 1)">‹</button>
          <span v-for="p in displayRoomPages" :key="p">
            <button class="page-btn" :class="{active:roomCurrentPage===p}" @click="changeRoomPage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="roomCurrentPage===roomTotalPages" @click="changeRoomPage(roomCurrentPage + 1)">›</button>
          <button class="page-btn" :disabled="roomCurrentPage===roomTotalPages" @click="changeRoomPage(roomTotalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="roomPageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpRoomPage">跳转</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 设备管理内容 -->
    <div v-if="activeTab === 'device'">
      <!-- 搜索区域 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields" style="display: flex; gap: 140px; align-items: center;">
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿舍楼：</label>
              <select class="form-input" v-model="deviceSearchForm.dormitory_name" style="flex: 1;">
                <option value="">全部</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>

          </div>

          <!-- <div class="form-fields" style="display: flex; gap: 140px; align-items: center; margin-top: 16px;">
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">床位号：</label>
              <input class="form-input" v-model="deviceSearchForm.bed_number" style="flex: 1;" placeholder="请输入床位号" />
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">设备状态：</label>
              <select class="form-input" v-model="deviceSearchForm.status" style="flex: 1;">
                <option value="">全部</option>
                <option value="online">在线</option>
                <option value="offline">离线</option>
              </select>
            </div>
          </div> -->

          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchDeviceData">
              查询
            </button>
            <button type="button" class="search-btn-green" @click="printDeviceData">
              打印
            </button>
          </div>
        </form>
      </div>

      <!-- 操作按钮 -->
      <div style="margin: 0 0 16px 8px; display: flex; gap: 12px;">
        <button class="search-btn-green" @click="showAddDeviceModal">新增设备</button>
      </div>

      <!-- 设备数据表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>楼栋名称</th>
                <th>设备编号</th>
                <th>设备品牌</th>
                <th>设备型号</th>
                <th>设备状态</th>
                <th>设备功能</th>
                <th>添加时间</th>
                <th>更新时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in deviceData" :key="item.id || idx">
                <td>{{ item.id || '-' }}</td>
                <td>{{ item.dormitory_name || '-' }}</td>
                <td>{{ item.code || '-' }}</td>
                <td>{{ item.brand || '-' }}</td>
                <td>{{ item.model || '-' }}</td>
                <td>
                  <span :class="item.status === 'online' ? 'status-online' : 'status-offline'">
                    {{ item.status === 'online' ? '在线' : '离线' }}
                  </span>
                </td>
                <td>
                  <span :class="item.access_type === 'in' ? 'status-in' : 'status-out'">
                    {{ item.access_type === 'in' ? '进门设备' : '出门设备' }}
                  </span>
                </td>
                <td>{{ item.add_time ? new Date(item.add_time).toLocaleString('zh-CN') : '-' }}</td>
                <td>{{ item.update_time ? new Date(item.update_time).toLocaleString('zh-CN') : '-' }}</td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showEditDeviceModal(item)">
                      编辑
                    </button>
                    <button class="search-btn-green" style="padding:4px 8px; background: #f44336;" @click="deleteDevice(item)">
                      删除
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="deviceData.length === 0">
                <td colspan="10" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="deviceCurrentPage===1" @click="changeDevicePage(1)">«</button>
          <button class="page-btn" :disabled="deviceCurrentPage===1" @click="changeDevicePage(deviceCurrentPage - 1)">‹</button>
          <span v-for="p in displayDevicePages" :key="p">
            <button class="page-btn" :class="{active:deviceCurrentPage===p}" @click="changeDevicePage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="deviceCurrentPage===deviceTotalPages" @click="changeDevicePage(deviceCurrentPage + 1)">›</button>
          <button class="page-btn" :disabled="deviceCurrentPage===deviceTotalPages" @click="changeDevicePage(deviceTotalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="devicePageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpDevicePage">跳转</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 宿管管理内容 -->
    <div v-if="activeTab === 'manager'">
      <!-- 搜索区域 -->
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields" style="display: flex; gap: 140px; align-items: center;">
            <!-- <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿管姓名：</label>
              <input class="form-input" v-model="managerSearchForm.name" style="flex: 1;" placeholder="姓名" />
            </div> -->
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿舍楼：</label>
              <select class="form-input" v-model="managerSearchForm.dormitory_name" style="flex: 1;">
                <option value="">全部</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
          </div>

          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchManagerData">
              查询
            </button>
            <button type="button" class="search-btn-green" @click="printManagerData">
              打印
            </button>
          </div>
        </form>
      </div>

      <!-- 操作按钮 -->
      <div style="margin: 0 0 16px 8px; display: flex; gap: 12px;">
        <button class="search-btn-green" @click="showAddManagerModal">新增</button>

      </div>

      <!-- 宿管数据表格 -->
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>宿管编号</th>
                <th>姓名</th>
                <th>性别</th>
                <th>管理的楼宇</th>
                <th>管理的楼层</th>
                <th>管理人数</th>
                <th>备注</th>
                <th>更新时间</th>
                <th>操作</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in managerData" :key="item.id || idx">
                <td>{{ item.id || '-' }}</td>
                <td>{{ item.manager_id || '-' }}</td>
                <td>{{ item.name || '-' }}</td>
                <td>
                  <span :class="item.gender === 'male' ? 'status-in' : 'status-out'">
                    {{ item.gender === 'male' ? '男' : '女' }}
                  </span>
                </td>
                <td>{{ item.dormitory_info?.dormitory_name || '-' }}</td>
                <td>{{ item.floor || '-' }}</td>
                <td>{{ item.managed_count || '-' }}</td>
                <td>{{ item.remark || '/' }}</td>
                <td>{{ item.updated_at ? new Date(item.updated_at).toLocaleString('zh-CN') : '-' }}</td>
                <td>
                  <div class="table-action-btns">
                    <button class="search-btn-green" style="padding:4px 8px;" @click="showEditManagerModal(item)">
                      编辑
                    </button>
                    <button class="search-btn-green" style="padding:4px 8px; background: #f44336;" @click="deleteManager(item)">
                      删除
                    </button>
                  </div>
                </td>
              </tr>
              <tr v-if="managerData.length === 0">
                <td colspan="10" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>

        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="managerCurrentPage===1" @click="changeManagerPage(1)">«</button>
          <button class="page-btn" :disabled="managerCurrentPage===1" @click="changeManagerPage(managerCurrentPage - 1)">‹</button>
          <span v-for="p in displayManagerPages" :key="p">
            <button class="page-btn" :class="{active:managerCurrentPage===p}" @click="changeManagerPage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="managerCurrentPage===managerTotalPages" @click="changeManagerPage(managerCurrentPage + 1)">›</button>
          <button class="page-btn" :disabled="managerCurrentPage===managerTotalPages" @click="changeManagerPage(managerTotalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="managerPageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpManagerPage">跳转</button>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增/编辑人员弹窗 -->
    <div v-if="showModal && activeTab === 'dormitory'" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">
            {{ isEdit ? '编辑人员' : '新增人员' }}
          </span>
          <button @click="closeModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <!-- 新增模式下显示所有字段 -->
          <template v-if="!isEdit">
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">姓名：</span>
              <input class="form-input" v-model="formData.name" style="width:400px;" placeholder="请输入姓名" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">工作单位：</span>
              <input class="form-input" v-model="formData.department" style="width:400px;" placeholder="请输入工作单位" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">居民身份证号：</span>
              <input class="form-input" v-model="formData.id_card" style="width:400px;" placeholder="请输入身份证号" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">性别：</span>
              <select class="form-input" v-model="formData.gender" style="width:400px;">
                <option value="">请选择性别</option>
                <option value="男">男</option>
                <option value="女">女</option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">宿舍楼：</span>
              <select class="form-input" v-model="formData.dormitory_name" style="width:400px;" @change="onDormitoryChange">
                <option value="">请选择宿舍楼</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">房间号：</span>
              <select class="form-input" v-model="formData.room_number" style="width:400px;" @change="onRoomChange" :disabled="!formData.dormitory_name">
                <option value="">请先选择宿舍楼</option>
                <option v-for="room in availableRooms" :key="room.id" :value="room.room_number">
                  {{ room.room_number }}
                </option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">床位号：</span>
              <select class="form-input" v-model="formData.bed_number" style="width:400px;" :disabled="!formData.room_number">
                <option value="">请先选择房间</option>
                <option v-for="bed in availableBeds" :key="bed.id" :value="bed.id">
                  {{ bed.bed_number }}
                </option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">联系方式：</span>
              <input class="form-input" v-model="formData.contact" style="width:400px;" placeholder="请输入联系方式" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">状态：</span>
              <select class="form-input" v-model="formData.access_type" style="width:400px;">
                <option value="in">在寝</option>
                <option value="out">未归寝</option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">人员编号：</span>
              <input class="form-input" v-model="formData.person_id" style="width:400px;" placeholder="请输入人员编号" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">照片：</span>
              <input 
                type="file" 
                accept="image/*" 
                @change="handleImageUpload" 
                style="width:400px;"
              />
            </div>
          </template>
          
          <!-- 编辑模式下只显示三个字段 -->
          <template v-else>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">性别：</span>
              <select class="form-input" v-model="formData.gender" style="width:400px;">
                <option value="">请选择性别</option>
                <option value="男">男</option>
                <option value="女">女</option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">工作单位：</span>
              <input class="form-input" v-model="formData.department" style="width:400px;" placeholder="请输入工作单位" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">居民身份证号：</span>
              <input class="form-input" v-model="formData.id_card" style="width:400px;" placeholder="请输入身份证号" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">联系方式：</span>
              <input class="form-input" v-model="formData.contact" style="width:400px;" placeholder="请输入联系方式" />
            </div>
            <!-- 新增床位相关字段 -->
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">宿舍楼：</span>
              <select class="form-input" v-model="formData.dormitory_name" style="width:400px;" @change="onEditDormitoryChange">
                <option value="">请选择宿舍楼</option>
                <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">房间号：</span>
              <select class="form-input" v-model="formData.room_number" style="width:400px;" @change="onEditRoomChange" :disabled="!formData.dormitory_name">
                <option value="">请先选择宿舍楼</option>
                <option v-for="room in editAvailableRooms" :key="room.id" :value="room.room_number">
                  {{ room.room_number }}
                </option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">床位号：</span>
              <select class="form-input" v-model="formData.bed_number" style="width:400px;" :disabled="!formData.room_number">
                <option value="">请先选择房间</option>
                <option v-for="bed in editAvailableBeds" :key="bed.id" :value="bed.id">
                  {{ bed.bed_number }}
                </option>
              </select>
            </div>
          </template>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="saveData" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closeModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑楼宇弹窗 -->
    <div v-if="showBuildingModal" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">
            {{ isEditBuilding ? '编辑楼宇' : '新增楼宇' }}
          </span>
          <button @click="closeBuildingModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">宿舍楼：</span>
            <input class="form-input" v-model="buildingFormData.building_name" style="width:400px;" placeholder="请输入楼宇名称" />
          </div>
          <!-- <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">单元数：</span>
            <input class="form-input" v-model="buildingFormData.unit_count" style="width:400px;" placeholder="请输入单元数" />
          </div> -->
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">楼宇层数：</span>
            <input class="form-input" v-model="buildingFormData.floors" style="width:400px;" placeholder="请输入楼宇层数" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">起始层：</span>
            <input class="form-input" v-model="buildingFormData.start_floor" style="width:400px;" placeholder="请输入起始层" />
          </div>
          <!-- <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">房间数：</span>
            <input class="form-input" v-model="buildingFormData.room_count" style="width:400px;" placeholder="请输入房间数" />
          </div> -->
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">楼宇类型：</span>
            <select class="form-input" v-model="buildingFormData.building_type" style="width:400px;">
              <option value="">请选择楼宇类型</option>
              <option value="独栋楼">独栋楼</option>
              <option value="联排楼">联排楼</option>
              <option value="公寓楼">公寓楼</option>
            </select>
          </div>
          <!-- <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">宿管：</span>
            <input class="form-input" v-model="buildingFormData.manager" style="width:400px;" placeholder="请输入宿管姓名" />
          </div> -->
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="saveBuildingData" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closeBuildingModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑房间弹窗 -->
    <div v-if="showRoomModal" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">
            {{ isEditRoom ? '编辑房间' : '新增房间' }}
          </span>
          <button @click="closeRoomModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">房间号：</span>
            <input class="form-input" v-model="roomFormData.room_number" style="width:400px;" placeholder="请输入房间号" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">房间类型：</span>
            <select class="form-input" v-model="roomFormData.room_type" style="width:400px;">
              <option value="">请选择房间类型</option>
              <option value="1人间">1人间</option>
              <option value="2人间">2人间</option>
              <option value="3人间">3人间</option>
              <option value="4人间">4人间</option>
              <option value="6人间">6人间</option>
            </select>
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">床位数：</span>
            <input class="form-input" v-model="roomFormData.capacity" style="width:400px;" placeholder="请输入床位数" type="number" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">已入住人数：</span>
            <input class="form-input" v-model="roomFormData.current_occupancy" style="width:400px;" placeholder="请输入已入住人数" type="number" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">房间备注：</span>
            <input class="form-input" v-model="roomFormData.remark" style="width:400px;" placeholder="请输入房间备注" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">所属楼宇：</span>
            <select class="form-input" v-model="roomFormData.dormitory" style="width:400px;">
              <option value="">请选择楼宇</option>
              <option v-for="building in buildingList" :key="building.id" :value="building.id">
                {{ building.building_name }}
              </option>
            </select>
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">所属楼层：</span>
            <input class="form-input" v-model="roomFormData.floor" style="width:400px;" placeholder="请输入所属楼层" type="number" />
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="saveRoomData" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closeRoomModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑床位弹窗 -->
    <div v-if="showBedModal" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">
            {{ isEditBed ? '编辑床位' : '新增床位' }}
          </span>
          <button @click="closeBedModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">宿舍楼：</span>
            <select class="form-input" v-model="bedFormData.dormitory_name" style="width:400px;" @change="onBedDormitoryChange">
              <option value="">请选择宿舍楼</option>
              <option v-for="option in dormitoryOptions" :key="option.value" :value="option.value">
                {{ option.label }}
              </option>
            </select>
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">房间号：</span>
            <select class="form-input" v-model="bedFormData.room" style="width:400px;" @change="onBedRoomChange" :disabled="!bedFormData.dormitory_name">
              <option value="">请先选择宿舍楼</option>
              <option v-for="room in bedAvailableRooms" :key="room.id" :value="room.id">
                {{ room.room_number }}
              </option>
            </select>
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">床位号：</span>
            <input class="form-input" v-model="bedFormData.bed_number" style="width:400px;" placeholder="请输入床位号" />
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="saveBedData" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closeBedModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑设备弹窗 -->
    <div v-if="showDeviceModal" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">
            {{ isEditDevice ? '编辑设备' : '新增设备' }}
          </span>
          <button @click="closeDeviceModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">设备编号：</span>
            <input class="form-input" v-model="deviceFormData.code" style="width:400px;" placeholder="请输入设备编号" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">设备品牌：</span>
            <input class="form-input" v-model="deviceFormData.brand" style="width:400px;" placeholder="请输入设备品牌" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">设备型号：</span>
            <input class="form-input" v-model="deviceFormData.model" style="width:400px;" placeholder="请输入设备型号" />
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">设备状态：</span>
            <select class="form-input" v-model="deviceFormData.status" style="width:400px;">
              <option value="">请选择设备状态</option>
              <option value="online">在线</option>
              <option value="offline">离线</option>
            </select>
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">设备功能：</span>
            <select class="form-input" v-model="deviceFormData.access_type" style="width:400px;">
              <option value="">请选择设备功能</option>
              <option value="in">进门设备</option>
              <option value="out">出门设备</option>
            </select>
          </div>
          <div style="display:flex;align-items:center;">
            <span style="width:120px;text-align:left;">所属楼栋：</span>
            <select class="form-input" v-model="deviceFormData.dormitory" style="width:400px;">
              <option value="">请选择楼栋</option>
              <option v-for="building in buildingList" :key="building.id" :value="building.id">
                {{ building.building_name }}
              </option>
            </select>
          </div>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="saveDeviceData" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closeDeviceModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>

    <!-- 新增/编辑宿管弹窗 -->
    <div v-if="showManagerModal" class="modal-mask" style="position:fixed;left:0;top:0;width:100vw;height:100vh;background:#0003;z-index:1000;display:flex;align-items:center;justify-content:center;">
      <div class="modal-content" style="background:#fff;padding:40px 60px 32px 60px;border-radius:8px;min-width:700px;position:relative;">
        <div style="display:flex;justify-content:space-between;align-items:center;margin-bottom:32px;">
          <span style="font-size:22px;color:#1976d2;font-weight:bold;border-bottom:3px solid #1976d2;padding-bottom:4px;">
            {{ isEditManager ? '编辑宿管' : '新增宿管' }}
          </span>
          <button @click="closeManagerModal" style="background:none;border:none;font-size:28px;cursor:pointer;line-height:1;">×</button>
        </div>
        <div style="display:flex;flex-direction:column;gap:18px;">
          <!-- 新增模式下显示所有字段 -->
          <template v-if="!isEditManager">
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">宿管编号：</span>
              <input class="form-input" v-model="managerFormData.manager_id" style="width:400px;" placeholder="请输入宿管编号" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">姓名：</span>
              <input class="form-input" v-model="managerFormData.name" style="width:400px;" placeholder="请输入姓名" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">性别：</span>
              <select class="form-input" v-model="managerFormData.gender" style="width:400px;">
                <option value="">请选择性别</option>
                <option value="male">男</option>
                <option value="female">女</option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">管理楼层：</span>
              <input class="form-input" v-model="managerFormData.floor" style="width:400px;" placeholder="请输入管理楼层，如：2-3" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">管理人数：</span>
              <input class="form-input" v-model="managerFormData.managed_count" style="width:400px;" placeholder="请输入管理人数" type="number" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">备注：</span>
              <input class="form-input" v-model="managerFormData.remark" style="width:400px;" placeholder="请输入备注" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">所属楼栋：</span>
              <select class="form-input" v-model="managerFormData.dormitory" style="width:400px;">
                <option value="">请选择楼栋</option>
                <option v-for="building in buildingList" :key="building.id" :value="building.id">
                  {{ building.building_name }}
                </option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">照片：</span>
              <input 
                type="file" 
                accept="image/*" 
                @change="handleManagerImageUpload" 
                style="width:400px;"
              />
            </div>
          </template>
          
          <!-- 编辑模式下只显示可编辑字段 -->
          <template v-else>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">管理楼层：</span>
              <input class="form-input" v-model="managerFormData.floor" style="width:400px;" placeholder="请输入管理楼层，如：2-3" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">性别：</span>
              <select class="form-input" v-model="managerFormData.gender" style="width:400px;">
                <option value="">请选择性别</option>
                <option value="male">男</option>
                <option value="female">女</option>
              </select>
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">管理人数：</span>
              <input class="form-input" v-model="managerFormData.managed_count" style="width:400px;" placeholder="请输入管理人数" type="number" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">备注：</span>
              <input class="form-input" v-model="managerFormData.remark" style="width:400px;" placeholder="请输入备注" />
            </div>
            <div style="display:flex;align-items:center;">
              <span style="width:120px;text-align:left;">所属楼栋：</span>
              <select class="form-input" v-model="managerFormData.dormitory" style="width:400px;">
                <option value="">请选择楼栋</option>
                <option v-for="building in buildingList" :key="building.id" :value="building.id">
                  {{ building.building_name }}
                </option>
              </select>
            </div>
          </template>
        </div>
        <div style="display:flex;justify-content:flex-end;gap:16px;margin-top:32px;">
          <button class="search-btn-green" @click="saveManagerData" style="min-width:80px;">保存</button>
          <button class="search-btn-green" @click="closeManagerModal" style="background:#eee;color:#333;min-width:80px;">取消</button>
        </div>
      </div>
    </div>
    <div v-if="activeTab === 'inout'">
      <div class="search-section search-section-new">
        <form class="search-form-2x2">
          <div class="form-fields" style="display: flex; flex-wrap: wrap; align-items: center;">
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">宿舍楼：</label>
              <select class="form-input" v-model="inoutFormData.person_record__buildid" style="flex: 1;min-width: 220px;">
                <option v-for="option in inoutBuildingOptions" :key="option.label" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">类型：</label>
              <select class="form-input" v-model="inoutFormData.access_type" style="flex: 1;min-width: 220px;">
                <option v-for="option in inoutAccessTypeOptions" :key="option.label" :value="option.value">
                  {{ option.label }}
                </option>
              </select>
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">开始日期：</label>
              <el-date-picker type="date" v-model="inoutFormData.start_date" />
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">结束日期：</label>
              <el-date-picker type="date" v-model="inoutFormData.end_date" />
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">工作单位：</label>
              <input class="form-input" v-model="inoutFormData.person_record__department" style="flex: 1;width: 220px;" placeholder="请输入工作单位" />
            </div>
            <div class="form-item" style="display: flex; align-items: center; min-width: 220px;">
              <label style="min-width: 80px; margin-right: 8px;">姓名：</label>
              <input class="form-input" v-model="inoutFormData.search" style="flex: 1;width: 220px;" placeholder="请输入姓名" />
            </div>
          </div>
          <div class="form-btns">
            <button type="button" class="search-btn-green" @click="searchInoutData">
              查询
            </button>
          </div>
        </form>
      </div>
      <div class="data-section">
        <div class="table-container">
          <table class="data-table">
            <thead>
              <tr>
                <th>序号</th>
                <th>姓名</th>
                <th>工作单位</th>
                <th>身份证号</th>
                <th>性别</th>
                <th>宿舍楼</th>
                <th>房间号</th>
                <th>床位号</th>
                <th>联系方式</th>
                <th>照片</th>
                <th>类型</th>
                <th>记录时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(item, idx) in inoutData" :key="item.id || idx">
                <td>{{ idx + 1 }}</td>
                <td>{{ item.person_record.name }}</td>
                <td>{{ item.person_record.department }}</td>
                <td>{{ item.person_record.id_card }}</td>
                <td>{{ item.person_record.gender }}</td>
                <td>{{ item.person_record.room_info.dormitory_name }}</td>
                <td>{{ item.person_record.room_info.room_number }}</td>
                <td>{{ item.person_record.room_info.bed_number }}</td>
                <td>{{ item.person_record.contact }}</td>
                <td>
                  <el-image style="width: 20px; height: 20px" :src="item.person_record.face_url" :preview-src-list="[item.person_record.face_url]" v-if="item.person_record.face_url != ''"></el-image>
                  <span v-else>----</span>
                </td>
                <td>
                  <span :class="item.access_type === 'in' ? 'status-in' : 'status-out'">
                    {{ item.access_type === 'in' ? '入宿' : '出宿' }}
                  </span>
                </td>
                <td>{{ item.record_time }}</td>
              </tr>
              <tr v-if="inoutData.length === 0">
                <td colspan="10" style="text-align:center;color:#bbb;">暂无数据</td>
              </tr>
            </tbody>
          </table>
        </div>
        <!-- 分页 -->
        <div class="pagination">
          <button class="page-btn" :disabled="inoutCurrentPage===1" @click="changeInoutPage(1)">«</button>
          <button class="page-btn" :disabled="inoutCurrentPage===1" @click="changeInoutPage(inoutCurrentPage - 1)">‹</button>
          <span v-for="p in displayInoutPages" :key="p">
            <button class="page-btn" :class="{active:inoutCurrentPage===p}" @click="changeInoutPage(p)">{{p}}</button>
          </span>
          <button class="page-btn" :disabled="inoutCurrentPage===inoutTotalPages" @click="changeInoutPage(inoutCurrentPage + 1)">›</button>
          <button class="page-btn" :disabled="inoutCurrentPage===inoutTotalPages" @click="changeInoutPage(inoutTotalPages)">»</button>
          <div class="page-jump">
            <input type="text" v-model="inoutPageInput" style="width:50px;" />
            <button class="jump-btn" @click="jumpInoutPage">跳转</button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { HTTP_CONFIG } from '@/config/config.js'
import axios from 'axios'
import XLSX from 'xlsx-js-style'

export default {
  name: 'DormitoryManage',
  data() {
    return {
      activeTab: 'dormitory', // 当前激活的tab
      searchForm: {
        dormitory_name: '',
        room_number: '',
        name: '',
        department: '',
      },
      searchFormed: {
        dormitory_name: '',
        room_number: '',
        name: '',
        department: ''
      },
      buildingSearchForm: {
        building_name: '',
        building_type: ''
      },
      formData: {
        name: '',
        department: '',
        id_card: '',
        gender: '',
        dormitory_name: '',
        room_number: '',
        bed_number: '',
        contact: '',
        access_type: 'in',
        person_id: '',
        face_data: ''
      },
      buildingFormData: {
        building_name: '',
        unit_count: '',
        floors: '',
        start_floor: '',
        room_count: '',
        building_type: '',
        manager: ''
      },
      showModal: false,
      showBuildingModal: false,
      showRoomModal: false,
      showBedModal: false,
      isEdit: false,
      isEditBuilding: false,
      isEditRoom: false,
      isEditBed: false,
      currentPage: 1,
      pageSize: 10,
      totalPages: 1,
      pageInput: '',
      personnelData: [],
      buildingData: [],
      totalCount: 0,
      loading: false,
      // 楼宇管理分页
      buildingCurrentPage: 1,
      buildingPageSize: 10,
      buildingTotalPages: 1,
      buildingPageInput: '',
      buildingTotalCount: 0,
      // 房间管理数据
      roomSearchForm: {
        dormitory_name: '',
        room_number: '',
        floor: '',
        dormitory_id: ''
      },
      roomFormData: {
        room_number: '',
        room_type: '',
        capacity: '',
        current_occupancy: '',
        remark: '',
        dormitory: '',
        floor: ''
      },
      roomData: [],
      roomCurrentPage: 1,
      roomPageSize: 10,
      roomTotalPages: 1,
      roomPageInput: '',
      roomTotalCount: 0,
      buildingList: [], // 用于存储楼宇列表，供新增房间时选择
      // 床位管理数据
      bedSearchForm: {
        dormitory_name: '',
        room_number: '',
        bed_number: ''
      },
      bedFormData: {
        id: '',
        dormitory: '',
        dormitory_name: '',
        room: '',
        bed_number: '',
        status: 'vacant'
      },
      bedData: [],
      bedCurrentPage: 1,
      bedPageSize: 10,
      bedTotalPages: 1,
      bedPageInput: '',
      bedTotalCount: 0,
      roomList: [], // 用于存储房间列表，供新增床位时选择
      bedAvailableRooms: [], // 床位管理专用的可用房间列表
      // 设备管理数据
      deviceSearchForm: {
        dormitory_name: '',
        room_number: '',
        bed_number: '',
        status: ''
      },
      deviceFormData: {
        id: '',
        code: '',
        brand: '',
        model: '',
        status: '',
        access_type: '',
        dormitory: ''
      },
      deviceData: [],
      deviceCurrentPage: 1,
      devicePageSize: 10,
      deviceTotalPages: 1,
      devicePageInput: '',
      deviceTotalCount: 0,
      showDeviceModal: false,
      isEditDevice: false,
      managerSearchForm: {
        name: '',
        dormitory_name: ''
      },
      managerData: [],
      managerCurrentPage: 1,
      managerTotalPages: 1,
      managerPageInput: '',
      showManagerModal: false,
      isEditManager: false,
      managerFormData: {
        manager_id: '',
        name: '',
        gender: '',
        floor: '',
        managed_count: '',
        remark: '',
        dormitory: '',
        face_data: ''
      },
      managerPageSize: 10,
      managerTotalCount: 0,
      // 出入管理数据
      inoutData: [],
      inoutTotalCount: 0,
      inoutCurrentPage: 1,
      inoutPageInput: '',
      inoutPageSize: 10,
      inoutTotalPages: 1,
      inoutBuildingOptions: [], // 用于存储所有搜索区域的宿舍楼选项
      inoutAccessTypeOptions: [
        { label: '全部', value: '' },
        { label: '入宿', value: 'in' },
        { label: '出宿', value: 'out' }
      ],
      inoutFormData: {
        start_date: null,
        end_date: null,
        person_record__buildid: 0,
        person_record__department: '',
        access_type: '',
        search: ''
      },
      // 新增：用于存储可用的房间和床位列表
      availableRooms: [],
      availableBeds: [],
      // 新增：编辑模式专用的房间和床位列表
      editAvailableRooms: [],
      editAvailableBeds: [],
      dormitoryOptions: [] // 用于存储所有搜索区域的宿舍楼选项
    }
  },
  computed: {
    pagedData() {
      return this.personnelData;
    },
    
    // 新增：生成显示的页码范围，最多显示10页
    displayPages() {
      const total = this.totalPages;
      const current = this.currentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayBedPages() {
      const total = this.bedTotalPages;
      const current = this.bedCurrentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayBuildingPages() {
      const total = this.buildingTotalPages;
      const current = this.buildingCurrentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayRoomPages() {
      const total = this.roomTotalPages;
      const current = this.roomCurrentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayDevicePages() {
      const total = this.deviceTotalPages;
      const current = this.deviceCurrentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },
    
    displayManagerPages() {
      const total = this.managerTotalPages;
      const current = this.managerCurrentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    },

    displayInoutPages() {
      const total = this.inoutTotalPages;
      const current = this.inoutCurrentPage;
      const maxDisplay = 10;
      
      if (total <= maxDisplay) {
        return Array.from({ length: total }, (_, i) => i + 1);
      }
      
      let start = Math.max(1, current - Math.floor(maxDisplay / 2));
      let end = Math.min(total, start + maxDisplay - 1);
      
      if (end - start + 1 < maxDisplay) {
        start = Math.max(1, end - maxDisplay + 1);
      }
      
      return Array.from({ length: end - start + 1 }, (_, i) => start + i);
    }
  },
  methods: {
    // 切换tab
    switchTab(tab) {
      this.activeTab = tab;
      if (tab === 'dormitory') {
        this.loadPersonnelData();
      } else if (tab === 'bed') {
        this.loadBedData();
      } else if (tab === 'building') {
        this.loadBuildingData();
      } else if (tab === 'room') {
        this.loadRoomData();
      } else if (tab === 'device') {
        this.loadDeviceData();
      } else if (tab === 'manager') {
        this.loadManagerData();
      } else if (tab === 'inout') {
        const now = new Date()
        const padZero = n => n < 10 ? `0${n}` : n
        this.inoutFormData.end_date = now;
        let year = now.getFullYear()
        let month = now.getMonth() + 1
        let day = now.getDate()
        month = month - 1
        if(month == 0) {
          year = year - 1
          month = 12
        }
        const month1 = padZero(month)
        const day1 = padZero(day)
        const startDate = `${year}-${month1}-${day1}`
        this.inoutFormData.start_date = new Date(startDate);
        this.inoutBuildingOptions = this.buildingData.map((item) => ({
          value: item.id,
          label: item.building_name
        })); // 使用楼宇管理的楼宇选项
        this.inoutBuildingOptions.unshift({ value: 0, label: '全部' }); // 添加“全部”选项
        this.loadInoutData();
      }
    },

    // 获取认证信息
getAuthHeaders() {
  return {
    'Content-Type': 'application/json',
    'Authorization': `Bearer ${localStorage.getItem('token') || ''}`
  };
},

    // 刷新数据
    async refreshData() {
      if (this.activeTab === 'dormitory') {
        this.currentPage = 1;
        await this.loadPersonnelData();
      } else if (this.activeTab === 'bed') {
        this.bedCurrentPage = 1;
        await this.loadBedData();
      } else if (this.activeTab === 'building') {
        this.buildingCurrentPage = 1;
        await this.loadBuildingData();
      } else if (this.activeTab === 'room') {
        this.roomCurrentPage = 1;
        await this.loadRoomData();
      } else if (this.activeTab === 'device') {
        this.deviceCurrentPage = 1;
        await this.loadDeviceData();
      } else if (this.activeTab === 'manager') {
        this.managerCurrentPage = 1;
        await this.loadManagerData();
      }
    },

    // 搜索数据
    async searchData() {
      this.currentPage = 1;
      await this.loadPersonnelData();
    },

    // 搜索楼宇数据
    async searchBuildingData() {
      this.buildingCurrentPage = 1;
      await this.loadBuildingData();
    },

    // 搜索房间数据
    async searchRoomData() {
      this.roomCurrentPage = 1;
      await this.loadRoomData();
    },

    // 搜索床位数据
    async searchBedData() {
      this.bedCurrentPage = 1;
      await this.loadBedData();
    },

    // 搜索设备数据
    async searchDeviceData() {
      this.deviceCurrentPage = 1;
      await this.loadDeviceData();
    },

    // 搜索宿管数据
    async searchManagerData() {
      this.managerCurrentPage = 1;
      await this.loadManagerData();
    },

    async searchInoutData() {
      this.inoutCurrentPage = 1;
      this.loadInoutData();
    },

    // 重置搜索
    resetSearch() {
      this.searchForm = {
        dormitory_name: '',
        room_number: '',
        name: '',
        department: ''
      };
      this.currentPage = 1;
      this.loadPersonnelData();
    },

   // 修改宿舍人员管理的打印功能
async printDormitoryData() {
  const params = new URLSearchParams();
  if (this.searchForm.dormitory_name) {
    params.append('dormitory_name', this.searchForm.dormitory_name);
  }
  if (this.searchForm.room_number) {
    params.append('room_number', this.searchForm.room_number);
  }
  if (this.searchForm.name) {
    params.append('name', this.searchForm.name);
  }
  if (this.searchForm.department) {
    params.append('department', this.searchForm.department);
  }
  params.append('page', 1);
  params.append('page_size', 100);
  let allPersonnelData = [];
  let next = `${HTTP_CONFIG.SERVER_ADDR}/personnels/?${params.toString()}`
  do {
    const response = await fetch(next, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        ...this.getAuthHeaders()
      }
    })
    const data = await response.json();
    next = data.data.next
    if(next != null) {
      let nextMatch = next.split('?')
      next = `${HTTP_CONFIG.SERVER_ADDR}/personnels/?` + nextMatch[1]
    }
    allPersonnelData = [...allPersonnelData, ...data.data.results]
  } while(next != null)
  let excel = [
    ['姓名', '工作单位', '性别', '宿舍楼', '房间号', '床位号', '联系方式', '状态']
  ]
  for(let i = 0;i < allPersonnelData.length;i++) {
    let line = []
    let item = allPersonnelData[i]
    line.push(item.name)
    line.push(item.department)
    line.push(item.gender)
    line.push(item.room_info.dormitory_name)
    line.push(item.room_info.room_number)
    line.push(item.room_info.bed_number)
    line.push(item.contact)
    if(item.access_type == 'in') {
      line.push('在寝')
    }
    else {
      line.push('未归寝')
    }
    excel.push(line)
  }
  const ws = XLSX.utils.aoa_to_sheet(excel);
  ws['!cols'] = [{ wch: 20 },{ wch: 40 },{ wch: 20 },{ wch: 20 },{ wch: 20 },{ wch: 20 },{ wch: 20 },{ wch: 20 }]
  let height = []
  var range = XLSX.utils.decode_range(ws['!ref'])
  for (var R = range.s.r; R <= range.e.r; ++R) {
    if(R == range.s.r) height.push({hpx: 40})
    else height.push({hpx: 20})
    for (var C = range.s.c; C <= range.e.c; ++C) {
      var cell_ref = XLSX.utils.encode_cell({ r: R, c: C })
      var cell = ws[cell_ref]
      if (cell) {
        if (!cell.s) cell.s = {}
        if(R == range.s.r) {
          cell.s = {
            font: {
              sz: 18,
              name: '宋体',
              bold: true,
            },
            alignment: {
              vertical: 'center',
              horizontal: 'center',
            },
          }
        }
        else {
          cell.s = {
            font: {
              sz: 14,
              name: '宋体',
            },
            alignment: {
              wrapText: 1,
              vertical: 'center',
              horizontal: 'center',
            },
          }
        }
      }
    }
  }
  ws['!rows'] = height
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, '宿舍人员管理');
  const buffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' })
  const blob = new Blob([buffer], { type: 'application/octet-stream' })
  try {
    if ('showSaveFilePicker' in window) {
      const opts = {
        types: [
          {
            description: "Excel Files",
            accept: { "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet": [".xlsx"] },
          },
        ],
      }
      const handle = await window.showSaveFilePicker(opts);
      const writable = await handle.createWritable();
      await writable.write(blob);
      await writable.close();
    } else {
      const url = URL.createObjectURL(blob)
      let el = document.createElement('a')
      el.href = url
      el.download ="宿舍人员管理.xlsx"
      document.body.appendChild(el)
      el.click()
      document.body.removeChild(el)
      URL.revokeObjectURL(url)
    }
  } catch (error) {
    console.error('写入文件失败:', error);
  }
},

// 修改楼宇管理的打印功能
async printBuildingData() {
  try {
    console.log('=== 开始打印楼宇管理数据 ===');
    
    // 构建查询参数，设置page_size为500获取所有数据
    const params = new URLSearchParams();
    if (this.buildingSearchForm.building_name) {
      params.append('name', this.buildingSearchForm.building_name);
    }
    if (this.buildingSearchForm.building_type) {
      params.append('building_type', this.buildingSearchForm.building_type);
    }
    params.append('page', 1);
    params.append('page_size', 500); // 设置每页500条数据
    
    console.log('打印查询参数:', params.toString());
    
    // 调用API获取所有数据
    const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/hostels/?${params.toString()}`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    const data = await response.json();
    let allBuildingData = [];
    
    if (data.code === 200 && data.data) {
      allBuildingData = (data.data.results || []).map(item => ({
        id: item.id,
        building_name: item.name,
        floors: item.floor_count,
        start_floor: item.start_floor,
        building_type: item.building_type,
        manager: item.manager_info?.manager_name || '-',
        update_time: item.updated_at ? new Date(item.updated_at).toLocaleString('zh-CN') : '-'
      }));
      console.log('API返回数据:', allBuildingData);
      console.log('数据数组长度:', allBuildingData.length);
    } else {
      console.error('获取打印数据失败:', data.message);
      allBuildingData = this.buildingData;
    }

    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">楼宇管理列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allBuildingData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">楼宇名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">楼宇层数</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">起始层</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">楼宇类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">宿管</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">更新时间</th>
            </tr>
          </thead>
          <tbody>
            ${allBuildingData.map((item, index) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.building_name || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.floors || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.start_floor || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.building_type || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.manager || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.update_time || '-'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 楼宇管理打印完成 ===');
    
  } catch (error) {
    console.error('打印楼宇管理数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},



// 修改床位管理的打印功能
async printBedData() {
  try {
    console.log('=== 开始打印床位管理数据 ===');
    
    // 构建查询参数，设置page_size为500获取所有数据
    const params = new URLSearchParams();
    if (this.bedSearchForm.dormitory_name) {
      params.append('dormitory_name', this.bedSearchForm.dormitory_name);
    }
    if (this.bedSearchForm.room_number) {
      params.append('room_number', this.bedSearchForm.room_number);
    }
    if (this.bedSearchForm.bed_number) {
      params.append('bed_number', this.bedSearchForm.bed_number);
    }
    params.append('page', 1);
    params.append('page_size', 500); // 设置每页500条数据
    
    console.log('打印查询参数:', params.toString());
    
    // 调用API获取所有数据
    const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/?${params.toString()}`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    const data = await response.json();
    let allBedData = [];
    
    if (data.code === 200 && data.data) {
      allBedData = (data.data.results || []).map(item => ({
        id: item.id,
        room_info: item.room_info,
        bed_number: item.bed_number,
        personnel_info: item.personnel_info
      }));
      console.log('API返回数据:', allBedData);
      console.log('数据数组长度:', allBedData.length);
    } else {
      console.error('获取打印数据失败:', data.message);
      allBedData = this.bedData;
    }

    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">床位管理列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allBedData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">宿舍楼</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">房间号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">床位号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">状态</th>
            </tr>
          </thead>
          <tbody>
            ${allBedData.map((item, index) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.room_info?.dormitory_name || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.room_info?.room_number || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.bed_number || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.personnel_info ? '已占用' : '空闲'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 床位管理打印完成 ===');
    
  } catch (error) {
    console.error('打印床位管理数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改设备管理的打印功能
async printDeviceData() {
  try {
    console.log('=== 开始打印设备管理数据 ===');
    
    // 构建查询参数，设置page_size为500获取所有数据
    const params = new URLSearchParams();
    if (this.deviceSearchForm.dormitory_name) {
      params.append('dormitory_name', this.deviceSearchForm.dormitory_name);
    }
    if (this.deviceSearchForm.room_number) {
      params.append('room_number', this.deviceSearchForm.room_number);
    }
    if (this.deviceSearchForm.bed_number) {
      params.append('bed_number', this.deviceSearchForm.bed_number);
    }
    if (this.deviceSearchForm.status) {
      params.append('status', this.deviceSearchForm.status);
    }
    params.append('page', 1);
    params.append('page_size', 500); // 设置每页500条数据
    
    console.log('打印查询参数:', params.toString());
    
    // 调用API获取所有数据
    const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/devices/?${params.toString()}`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    const data = await response.json();
    let allDeviceData = [];
    
    if (data.code === 200 && data.data) {
      allDeviceData = data.data.results || [];
      console.log('API返回数据:', allDeviceData);
      console.log('数据数组长度:', allDeviceData.length);
    } else {
      console.error('获取打印数据失败:', data.message);
      allDeviceData = this.deviceData;
    }

    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">设备管理列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allDeviceData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">楼栋名称</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备品牌</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备型号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备状态</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">设备功能</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">添加时间</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">更新时间</th>
            </tr>
          </thead>
          <tbody>
            ${allDeviceData.map((item, index) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.dormitory_name || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.code || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.brand || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.model || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.status === 'online' ? '在线' : '离线'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.access_type === 'in' ? '进门设备' : '出门设备'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.add_time ? new Date(item.add_time).toLocaleString('zh-CN') : '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.update_time ? new Date(item.update_time).toLocaleString('zh-CN') : '-'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 设备管理打印完成 ===');
    
  } catch (error) {
    console.error('打印设备管理数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

// 修改宿管管理的打印功能
async printManagerData() {
  try {
    console.log('=== 开始打印宿管管理数据 ===');
    
    // 构建查询参数，设置page_size为500获取所有数据
    const params = new URLSearchParams();
    if (this.managerSearchForm.name) {
      params.append('name', this.managerSearchForm.name);
    }
    if (this.managerSearchForm.dormitory_name) {
      params.append('dormitory_name', this.managerSearchForm.dormitory_name);
    }
    params.append('page', 1);
    params.append('page_size', 500); // 设置每页500条数据
    
    console.log('打印查询参数:', params.toString());
    
    // 调用API获取所有数据
    const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/managers/?${params.toString()}`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    const data = await response.json();
    let allManagerData = [];
    
    if (data.code === 200 && data.data) {
      allManagerData = data.data.results || [];
      console.log('API返回数据:', allManagerData);
      console.log('数据数组长度:', allManagerData.length);
    } else {
      console.error('获取打印数据失败:', data.message);
      allManagerData = this.managerData;
    }

    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">宿管管理列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allManagerData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">宿管编号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">姓名</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">性别</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">管理的楼宇</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">管理的楼层</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">管理人数</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">备注</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">更新时间</th>
            </tr>
          </thead>
          <tbody>
            ${allManagerData.map((item, index) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.manager_id || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.name || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.gender === 'male' ? '男' : '女'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.dormitory_info?.dormitory_name || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.floor || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.managed_count || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.remark || '/'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.updated_at ? new Date(item.updated_at).toLocaleString('zh-CN') : '-'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 宿管管理打印完成 ===');
    
  } catch (error) {
    console.error('打印宿管管理数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

    // 重置楼宇搜索
    resetBuildingSearch() {
      this.buildingSearchForm = {
        building_name: '',
        building_type: ''
      };
      this.buildingCurrentPage = 1;
      this.loadBuildingData();
    },

  
    

    // 重置房间搜索
    resetRoomSearch() {
      this.roomSearchForm = {
        dormitory_name: '',
        room_number: '',
        floor: '',
        dormitory_id: ''
      };
      this.roomCurrentPage = 1;
      this.loadRoomData();
    },

    // 打印房间数据
    async printRoomData() {
  try {
    console.log('=== 开始打印房间管理数据 ===');
    
    // 构建查询参数，设置page_size为500获取所有数据
    const params = new URLSearchParams();
    if (this.roomSearchForm.dormitory_name) {
      params.append('dormitory_name', this.roomSearchForm.dormitory_name);
    }
    if (this.roomSearchForm.room_number) {
      params.append('room_number', this.roomSearchForm.room_number);
    }
    if (this.roomSearchForm.floor) {
      params.append('floor', this.roomSearchForm.floor);
    }
    if (this.roomSearchForm.dormitory_id) {
      params.append('dormitory_id', this.roomSearchForm.dormitory_id);
    }
    params.append('page', 1);
    params.append('page_size', 500); // 设置每页500条数据
    
    console.log('打印查询参数:', params.toString());
    
    // 调用API获取所有数据
    const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/?${params.toString()}`, {
      method: 'GET',
      headers: this.getAuthHeaders()
    });

    const data = await response.json();
    let allRoomData = [];
    
    if (data.code === 200 && data.data) {
      allRoomData = (data.data.results || []).map(item => ({
        id: item.id,
        room_number: item.room_number,
        room_type: item.room_type,
        dormitory_info: item.dormitory_info,
        floor: item.floor,
        capacity: item.capacity,
        current_occupancy: item.current_occupancy,
        remark: item.remark
      }));
      console.log('API返回数据:', allRoomData);
      console.log('数据数组长度:', allRoomData.length);
    } else {
      console.error('获取打印数据失败:', data.message);
      allRoomData = this.roomData;
    }

    // 生成打印内容
    const printContent = `
      <div style="padding: 20px;">
        <h2 style="text-align: center; margin-bottom: 20px;">房间管理列表</h2>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          打印时间: ${new Date().toLocaleString('zh-CN')}
        </div>
        <div style="margin-bottom: 10px; text-align: right; color: #666;">
          总记录数: ${allRoomData.length} 条
        </div>
        <table style="width: 100%; border-collapse: collapse; border: 1px solid #ddd;">
          <thead>
            <tr style="background: #f5f5f5;">
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">序号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">房间号</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">房间类型</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">所属楼宇</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">所属楼层</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">入住数量/床位总数</th>
              <th style="border: 1px solid #ddd; padding: 8px; text-align: center;">备注</th>
            </tr>
          </thead>
          <tbody>
            ${allRoomData.map((item, index) => `
              <tr>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${index + 1}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.room_number || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.room_type || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.dormitory_info?.dormitory_name || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.floor || '-'}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.current_occupancy}/${item.capacity}</td>
                <td style="border: 1px solid #ddd; padding: 8px; text-align: center;">${item.remark || '/'}</td>
              </tr>
            `).join('')}
          </tbody>
        </table>
      </div>
    `;
    
    // 打开打印窗口
    const printWindow = window.open('', '_blank');
    printWindow.document.write(printContent);
    printWindow.document.close();
    printWindow.print();
    printWindow.close();
    
    console.log('=== 房间管理打印完成 ===');
    
  } catch (error) {
    console.error('打印房间管理数据失败:', error);
    alert('打印失败，请查看控制台');
  }
},

    // 重置床位搜索
    resetBedSearch() {
      this.bedSearchForm = {
        dormitory_name: '',
        room_number: '',
        bed_number: ''
      };
      this.bedCurrentPage = 1;
      this.loadBedData();
    },


    // 重置设备搜索
    resetDeviceSearch() {
      this.deviceSearchForm = {
        dormitory_name: '',
        room_number: '',
        bed_number: '',
        status: ''
      };
      this.deviceCurrentPage = 1;
      this.loadDeviceData();
    },


    // 重置宿管搜索
    resetManagerSearch() {
      this.managerSearchForm = {
        name: '',
        dormitory_name: ''
      };
      this.managerCurrentPage = 1;
      this.loadManagerData();
    },

    base64ToImage(base64Str) {
      if(base64Str == '') {
          return '';
      }
      try {
          // 2. 解码 Base64 为二进制字符串
          const binaryString = window.atob(base64Str);
          // 3. 将二进制字符串转换为 Uint8Array
          const len = binaryString.length;
          const bytes = new Uint8Array(len);
          for (let i = 0; i < len; i++) {
              bytes[i] = binaryString.charCodeAt(i);
          }
          // 4. 创建 Blob 对象
          const blob = new Blob([bytes], { type: 'image/jpeg' });
          // 5. 创建临时 URL
          const imageUrl = URL.createObjectURL(blob);
          return imageUrl;
      } catch (e) {
          console.error("Base64 转换失败:", e);
          return '';
      }
    },
    // 加载人员数据
    async loadPersonnelData() {
      try {
        this.loading = true;
        
        // 构建查询参数
        const params = new URLSearchParams();
        if (this.searchForm.dormitory_name) {
          params.append('dormitory_name', this.searchForm.dormitory_name);
        }
        if (this.searchForm.room_number) {
          params.append('room_number', this.searchForm.room_number);
        }
        if (this.searchForm.name) {
          params.append('name', this.searchForm.name);
        }
        if (this.searchForm.department) {
          params.append('department', this.searchForm.department);
        }
        this.searchFormed.dormitory_name = this.searchForm.dormitory_name
        this.searchFormed.room_number = this.searchForm.room_number
        this.searchFormed.name = this.searchForm.name
        this.searchFormed.department = this.searchForm.department
        params.append('page', this.currentPage);
        params.append('page_size', this.pageSize);
        // 释放创建的临时 URL 对象，避免内存泄漏
        for(let i = 0; i < this.personnelData.length; i++) {
          const item = this.personnelData[i];
          if(item.face_url != '') {
            URL.revokeObjectURL(item.face_url);
          }
        }
        this.personnelData = [];
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/personnels/?${params.toString()}`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          }
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          // 解析返回的数据结构
          this.personnelData = data.data.results || [];
          this.totalCount = data.data.count || 0;
          this.totalPages = Math.ceil(this.totalCount / this.pageSize);
          for(let i = 0; i < this.personnelData.length; i++) {
            const item = this.personnelData[i];
            item.face_url = this.base64ToImage(item.face_data);
          }
        } else {
          console.error('获取数据失败:', data.message);
          this.personnelData = [];
          this.totalCount = 0;
          this.totalPages = 1;
        }
      } catch (error) {
        console.error('加载人员数据失败:', error);
        this.personnelData = [];
        this.totalCount = 0;
        this.totalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    // 加载楼宇数据
    async loadBuildingData() {
      try {
        this.loading = true;
        
        // 构建查询参数
        const params = new URLSearchParams();
        if (this.buildingSearchForm.building_name) {
          params.append('name', this.buildingSearchForm.building_name);
        }
        if (this.buildingSearchForm.building_type) {
          params.append('building_type', this.buildingSearchForm.building_type);
        }
        params.append('page', this.buildingCurrentPage);
        params.append('page_size', this.buildingPageSize);

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/hostels/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          // 解析返回的数据结构，转换为前端需要的格式
          this.buildingData = (data.data.results || []).map(item => ({
            id: item.id,
            building_name: item.name,
            unit_count: '/', 
            floors: item.floor_count,
            start_floor: item.start_floor,
            room_count: '/', 
            building_type: item.building_type,
            manager: item.manager_info?.manager_name || '-',
            update_time: item.updated_at ? new Date(item.updated_at).toLocaleString('zh-CN') : '-'
          }));
          
          // 同时更新buildingList用于房间管理
          this.buildingList = this.buildingData;
          
          // 设置分页信息
          this.buildingTotalCount = data.data.count || 0;
          this.buildingTotalPages = Math.ceil(this.buildingTotalCount / this.buildingPageSize);
        } else {
          console.error('获取楼宇数据失败:', data.message);
          this.buildingData = [];
          this.buildingTotalCount = 0;
          this.buildingTotalPages = 1;
        }
      } catch (error) {
        console.error('加载楼宇数据失败:', error);
        this.buildingData = [];
        this.buildingTotalCount = 0;
        this.buildingTotalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    // 加载房间数据
    async loadRoomData() {
      try {
        this.loading = true;
        
        // 构建查询参数
        const params = new URLSearchParams();
        if (this.roomSearchForm.dormitory_name) {
          params.append('dormitory_name', this.roomSearchForm.dormitory_name);
        }
        if (this.roomSearchForm.room_number) {
          params.append('room_number', this.roomSearchForm.room_number);
        }
        if (this.roomSearchForm.floor) {
          params.append('floor', this.roomSearchForm.floor);
        }
        if (this.roomSearchForm.dormitory_id) {
          params.append('dormitory_id', this.roomSearchForm.dormitory_id);
        }
        params.append('page', this.roomCurrentPage);
        params.append('page_size', this.roomPageSize);

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
                     // 解析返回的数据结构，转换为前端需要的格式
           this.roomData = (data.data.results || []).map(item => ({
             id: item.id,
             room_number: item.room_number,
             room_type: item.room_type,
             dormitory_info: item.dormitory_info,
             floor: item.floor,
             capacity: item.capacity,
             current_occupancy: item.current_occupancy,
             remark: item.remark,
             dormitory: item.dormitory, 
             update_time: item.updated_at ? new Date(item.updated_at).toLocaleString('zh-CN') : '-'
           }));
          
          // 设置分页信息
          this.roomTotalCount = data.data.count || 0;
          this.roomTotalPages = Math.ceil(this.roomTotalCount / this.roomPageSize);
        } else {
          console.error('获取房间数据失败:', data.message);
          this.roomData = [];
          this.roomTotalCount = 0;
          this.roomTotalPages = 1;
        }
      } catch (error) {
        console.error('加载房间数据失败:', error);
        this.roomData = [];
        this.roomTotalCount = 0;
        this.roomTotalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    // 加载床位数据
    async loadBedData() {
      try {
        this.loading = true;
        
        // 构建查询参数
        const params = new URLSearchParams();
        if (this.bedSearchForm.dormitory_name) {
          params.append('dormitory_name', this.bedSearchForm.dormitory_name);
        }
        if (this.bedSearchForm.room_number) {
          params.append('room_number', this.bedSearchForm.room_number);
        }
        if (this.bedSearchForm.bed_number) {
          params.append('bed_number', this.bedSearchForm.bed_number);
        }
        params.append('page', this.bedCurrentPage);
        params.append('page_size', this.bedPageSize);

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          // 解析返回的数据结构，转换为前端需要的格式
          this.bedData = (data.data.results || []).map(item => ({
            id: item.id,
            room_info: item.room_info,
            bed_number: item.bed_number,
            personnel_info: item.personnel_info,
            created_at: item.created_at,
            updated_at: item.updated_at
          }));
          
          // 设置分页信息
          this.bedTotalCount = data.data.count || 0;
          this.bedTotalPages = Math.ceil(this.bedTotalCount / this.bedPageSize);
        } else {
          console.error('获取床位数据失败:', data.message);
          this.bedData = [];
          this.bedTotalCount = 0;
          this.bedTotalPages = 1;
        }
      } catch (error) {
        console.error('加载床位数据失败:', error);
        this.bedData = [];
        this.bedTotalCount = 0;
        this.bedTotalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    showAddModal() {
      this.isEdit = false;
      this.formData = {
        name: '',
        department: '',
        gender: '',
        dormitory_name: '',
        room_number: '',
        bed_number: '',
        contact: '',
        access_type: 'in',
        person_id: '',
        face_data: ''
      };
      // 重置房间和床位列表
      this.availableRooms = [];
      this.availableBeds = [];
      this.showModal = true;
    },

    showEditModal(item) {
      this.isEdit = true;
      // 设置编辑接口需要的字段，包括床位相关信息
      this.formData = {
        id: item.id || '',
        gender: item.gender || '',
        department: item.department || '',
        id_card: item.id_card || '',
        contact: item.contact || '',
        // 新增床位相关字段
        dormitory_name: item.room_info?.dormitory_name || '',
        room_number: item.room_info?.room_number || '',
        bed_number: item.bed || '' // 使用bed_id而不是bed_number
      };
      
      // 重置编辑模式的房间和床位列表
      this.editAvailableRooms = [];
      this.editAvailableBeds = [];

      if(item.bed != null) {
        const data = {
          id: item.bed,
          bed_number: item.room_info?.bed_number || ''
        };
        this.editAvailableBeds.push(data);
      }
      try {
        const params = new URLSearchParams();
        if (this.formData.dormitory_name) {
          params.append('dormitory_name', this.formData.dormitory_name);
        }
        if (this.formData.room_number) {
          params.append('room_number', this.formData.room_number);
        }
        params.append('is_empty', 'true'); // 只获取空闲的床位
        params.append('page_size', 100);

        // const response = fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/?${params.toString()}`, {
        //   method: 'GET',
        //   headers: this.getAuthHeaders()
        // });
        
        axios.get(`${HTTP_CONFIG.SERVER_ADDR}/beds/?${params.toString()}`)
        .then(response => {
          const data = response.data;
          if (data.code === 200 && data.data.count > 0) {
            console.log(data.data.results);
            for(let ele of data.data.results) {
              this.editAvailableBeds.push(ele);
            }
        }})
      } catch (error) {
        console.error('加载编辑床位列表失败:');
      }
      
      // 如果有宿舍楼信息，加载对应的房间列表
      if (this.formData.dormitory_name) {
        this.loadEditAvailableRooms();
      }
      
      this.showModal = true;
    },

    closeModal() {
      this.showModal = false;
    },

    // 楼宇管理相关方法
    showAddBuildingModal() {
      this.isEditBuilding = false;
      this.buildingFormData = {
        building_name: '',
        unit_count: '',
        floors: '',
        start_floor: '',
        room_count: '',
        building_type: '',
        manager: ''
      };
      this.showBuildingModal = true;
    },

    showEditBuildingModal(item) {
      this.isEditBuilding = true;
      this.buildingFormData = { 
        id: item.id || '',
        building_name: item.building_name || '',
        unit_count: item.unit_count || '',
        floors: item.floors || '',
        start_floor: item.start_floor || '',
        room_count: item.room_count || '',
        building_type: item.building_type || '',
        manager: item.manager || ''
      };
      this.showBuildingModal = true;
    },

    closeBuildingModal() {
      this.showBuildingModal = false;
    },

    async saveBuildingData() {
      try {
        if (this.isEditBuilding) {
          // 编辑楼宇
          await this.editBuilding();
        } else {
          // 新增楼宇
          await this.addBuilding();
        }
        
        this.closeBuildingModal();
        await this.loadBuildingData(); // 重新加载数据
        alert(this.isEditBuilding ? '编辑楼宇成功！' : '新增楼宇成功！');
      } catch (error) {
        console.error('保存楼宇数据失败:', error);
        alert('保存失败：' + error.message);
      }
    },

    // 新增楼宇
    async addBuilding() {
      try {
        // 构建请求参数
        const requestData = {
          name: this.buildingFormData.building_name,
          floor_count: parseInt(this.buildingFormData.floors) || 0,
          start_floor: parseInt(this.buildingFormData.start_floor) || 0,
          building_type: this.buildingFormData.building_type
        };

        // 验证必填字段
        if (!requestData.name) {
          throw new Error('楼宇名称不能为空');
        }
        if (!requestData.floor_count || requestData.floor_count <= 0) {
          throw new Error('楼宇层数必须大于0');
        }
        if (!requestData.start_floor || requestData.start_floor <= 0) {
          throw new Error('起始层必须大于0');
        }
        if (!requestData.building_type) {
          throw new Error('楼宇类型不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/hostels/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('新增楼宇成功！');
        } else {
          throw new Error(result.message || '新增失败');
        }
      } catch (error) {
        console.error('新增楼宇失败:', error);
        throw error;
      }
    },

    // 编辑楼宇
    async editBuilding() {
      try {
        // 构建请求参数
        const requestData = {
          name: this.buildingFormData.building_name,
          floor_count: parseInt(this.buildingFormData.floors) || 0,
          start_floor: parseInt(this.buildingFormData.start_floor) || 0,
          building_type: this.buildingFormData.building_type
        };

        // 验证必填字段
        if (!requestData.name) {
          throw new Error('楼宇名称不能为空');
        }
        if (!requestData.floor_count || requestData.floor_count <= 0) {
          throw new Error('楼宇层数必须大于0');
        }
        if (!requestData.start_floor || requestData.start_floor <= 0) {
          throw new Error('起始层必须大于0');
        }
        if (!requestData.building_type) {
          throw new Error('楼宇类型不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/hostels/${this.buildingFormData.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('编辑楼宇成功！');
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑楼宇失败:', error);
        throw error;
      }
    },

    async deleteBuilding(item) {
      if (confirm(`确定要删除楼宇 ${item.building_name} 吗？`)) {
        try {
          // 调用删除楼宇接口
          await this.deleteBuildingAPI(item.id);
          await this.loadBuildingData(); // 重新加载数据
          alert('删除楼宇成功！');
        } catch (error) {
          console.error('删除楼宇失败:', error);
          alert('删除失败：' + error.message);
        }
      }
    },

    // 删除楼宇API调用
    async deleteBuildingAPI(buildingId) {
      try {
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/hostels/${buildingId}/`, {
          method: 'DELETE',
          headers: this.getAuthHeaders()
        });

        if (response.ok) {
          return true;
        } else {
          const result = await response.json();
          throw new Error(result.message || '删除失败');
        }
      } catch (error) {
        console.error('删除楼宇API调用失败:', error);
        throw error;
      }
    },

    exportBuildingData() {
      // TODO: 实现导出楼宇数据功能
      console.log('导出楼宇数据');
      alert('导出功能待实现');
    },

    async saveData() {
      try {
        if (this.isEdit) {
          // 编辑数据
          await this.editPerson();
        } else {
          // 新增数据
          await this.addPerson();
        }
        
        this.closeModal();
        await this.loadPersonnelData(); // 重新加载数据
      } catch (error) {
        console.error('保存数据失败:', error);
        alert('保存失败：' + error.message);
      }
    },

    strictIDCardCheck(id) {
      const aCity = {    11: "北京",12: "天津",13: "河北",14: "山西",15: "内蒙古",21: "辽宁",22: "吉林",23: "黑龙江",
        31: "上海",32: "江苏",33: "浙江",34: "安徽",35: "福建",36: "江西",37: "山东",41: "河南",42: "湖北",
        43: "湖南",44: "广东",45: "广西",46: "海南",50: "重庆",51: "四川", 52: "贵州", 53: "云南",54: "西藏",
        61: "陕西", 62: "甘肃",63: "青海",64: "宁夏",65: "新疆", 71: "台湾",81: "香港",82: "澳门",91: "国外",
      };
      // 验证长度
      if (!/^\d{17}(\d|x)$/i.test(id)) {
        return false;
      }
      // 验证前两位是否为省份代码
      id = id.replace(/x$/i, "a");
      if (aCity[parseInt(id.substr(0, 2))] == null) {
        return;
      }
      // 身份证上的出生年月校验
      const sBirthday =
        id.substr(6, 4) +
        "-" +
        Number(id.substr(10, 2)) +
        "-" +
        Number(id.substr(12, 2));
      const d = new Date(sBirthday.replace(/-/g, "/"));
      if (
        sBirthday !=
        d.getFullYear() + "-" + (d.getMonth() + 1) + "-" + d.getDate()
      ) {
        return false;
      }
      // 身份证校验位判断
      let iSum = 0;
      for (let i = 17; i >= 0; i--) {
        iSum += (Math.pow(2, i) % 11) * parseInt(id.charAt(17 - i), 11);
      }
      if (iSum % 11 != 1) {
        return false;
      }
      return true;
    },

    // 新增人员
    async addPerson() {
      try {
        // 构建请求参数
        const requestData = {
          person_id: this.formData.person_id || '',
          id_card: this.formData.id_card,
          name: this.formData.name,
          gender: this.formData.gender,
          department: this.formData.department,
          contact: this.formData.contact,
          bed: parseInt(this.formData.bed_number) || 0, // 床位号现在是床位ID
          face_data: this.formData.face_data || '' // 如果没有照片数据，传空字符串
        };

        if(!requestData.id_card) {
          throw new Error('请填写身份证号码');
        }
        if(this.strictIDCardCheck(requestData.id_card) == false) {
          throw new Error('身份证号码格式错误');
        }
        // 验证必填字段
        if (!requestData.name) {
          throw new Error('姓名不能为空');
        }
        if (!requestData.gender) {
          throw new Error('性别不能为空');
        }
        if (!requestData.department) {
          throw new Error('部门不能为空');
        }
        if (!requestData.contact) {
          throw new Error('联系方式不能为空');
        }
        if (!requestData.person_id) {
          throw new Error('人员编号不能为空');
        }
        if (!requestData.bed) {
          throw new Error('请选择床位');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/personnels/`, {
          method: 'POST',
          headers: this.getAuthHeaders(),
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('新增人员成功！');
        } else {
          throw new Error(result.message || '新增失败');
        }
      } catch (error) {
        console.error('新增人员失败:', error);
        throw error;
      }
    },

    // 编辑人员
    async editPerson() {
      try {
        // 构建请求参数
        const requestData = {
          id: this.formData.id,
          gender: this.formData.gender,
          department: this.formData.department,
          id_card: this.formData.id_card,
          contact: this.formData.contact,
          bed: parseInt(this.formData.bed_number) || 0 // 新增bed字段
        };

        if(!requestData.id_card) {
          throw new Error('请填写身份证号码');
        }
        // 验证必填字段
        if (!requestData.gender) {
          throw new Error('性别不能为空');
        }
        if (!requestData.department) {
          throw new Error('部门不能为空');
        }
        if (!requestData.contact) {
          throw new Error('联系方式不能为空');
        }
        if (!requestData.bed) {
          throw new Error('请选择床位');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/personnels/${this.formData.id}/`, {
          method: 'PATCH',
          headers: this.getAuthHeaders(),
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('编辑人员成功！');
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑人员失败:', error);
        throw error;
      }
    },

    async deletePerson(item) {
      if (confirm(`确定要删除 ${item.name} 吗？`)) {
        try {
          // 调用删除人员接口
          await this.deletePersonAPI(item.id);
          await this.loadPersonnelData(); // 重新加载数据
          alert('删除人员成功！');
        } catch (error) {
          console.error('删除人员失败:', error);
          alert('删除失败：' + error.message);
        }
      }
    },

    // 删除人员API调用
    async deletePersonAPI(personId) {
      try {
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/personnels/${personId}/`, {
          method: 'DELETE',
          headers: {
            'Content-Type': 'application/json',
            // 'Username': 'admin', // 这里需要根据实际情况设置用户名
            // 'Timestamp': Math.floor(Date.now() / 1000), // 当前时间戳（秒）
            // 'Token': 'your_token_here' // 这里需要根据实际情况设置token
          }
        });

        if (response.ok) {
          return true;
        } else {
          const result = await response.json();
          throw new Error(result.message || '删除失败');
        }
      } catch (error) {
        console.error('删除人员API调用失败:', error);
        throw error;
      }
    },

    async changePage(page) {
      this.currentPage = page;
      await this.loadPersonnelData();
    },

    async jumpPage() {
      const page = parseInt(this.pageInput);
      if (page >= 1 && page <= this.totalPages) {
        this.currentPage = page;
        await this.loadPersonnelData();
      }
      this.pageInput = '';
    },

    // 处理照片上传
    handleImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          // 获取Base64数据，去掉data:image/jpeg;base64,前缀
          const base64Data = e.target.result.split(',')[1];
          this.formData.face_data = base64Data;
        };
        reader.readAsDataURL(file);
      }
    },

    // 宿舍楼选择变化时，加载对应的房间列表
    async onDormitoryChange() {
      this.formData.room_number = '';
      this.formData.bed_number = '';
      this.availableRooms = [];
      this.availableBeds = [];
      
      if (this.formData.dormitory_name) {
        await this.loadAvailableRooms();
      }
    },

    // 房间选择变化时，加载对应的床位列表
    async onRoomChange() {
      this.formData.bed_number = '';
      this.availableBeds = [];
      
      if (this.formData.room_number) {
        await this.loadAvailableBeds();
      }
    },

    // 获取可用的房间列表
    async loadAvailableRooms() {
      try {
        const params = new URLSearchParams();
        if (this.formData.dormitory_name) {
          params.append('dormitory_name', this.formData.dormitory_name);
        }
        params.append('page_size', 100); // 获取更多房间数据

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.availableRooms = data.data.results || [];
        } else {
          console.error('获取房间列表失败:', data.message);
          this.availableRooms = [];
        }
      } catch (error) {
        console.error('加载房间列表失败:', error);
        this.availableRooms = [];
      }
    },

    // 获取可用的床位列表
    async loadAvailableBeds() {
      try {
        const params = new URLSearchParams();
        if (this.formData.dormitory_name) {
          params.append('dormitory_name', this.formData.dormitory_name);
        }
        if (this.formData.room_number) {
          params.append('room_number', this.formData.room_number);
        }
        params.append('is_empty', 'true'); // 只获取空闲的床位
        params.append('page_size', 100); // 获取更多床位数据

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.availableBeds = data.data.results || [];
        } else {
          console.error('获取床位列表失败:', data.message);
          this.availableBeds = [];
        }
      } catch (error) {
        console.error('加载床位列表失败:', error);
        this.availableBeds = [];
      }
    },

    // 床位管理：宿舍楼选择变化时，加载对应的房间列表
    async onBedDormitoryChange() {
      this.bedFormData.room = '';
      this.bedAvailableRooms = [];
      
      if (this.bedFormData.dormitory_name) {
        await this.loadBedAvailableRooms();
      }
    },

    // 床位管理：房间选择变化时的处理
    onBedRoomChange() {
      // 可以在这里添加房间选择后的逻辑
      console.log('床位管理房间选择变化:', this.bedFormData.room);
    },

    // 床位管理：获取可用的房间列表
    async loadBedAvailableRooms() {
      try {
        const params = new URLSearchParams();
        if (this.bedFormData.dormitory_name) {
          params.append('dormitory_name', this.bedFormData.dormitory_name);
        }
        params.append('page_size', 100); // 获取更多房间数据

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.bedAvailableRooms = data.data.results || [];
        } else {
          console.error('获取床位管理房间列表失败:', data.message);
          this.bedAvailableRooms = [];
        }
      } catch (error) {
        console.error('加载床位管理房间列表失败:', error);
        this.bedAvailableRooms = [];
      }
    },

    // 楼宇管理分页相关方法
    async changeBuildingPage(page) {
      this.buildingCurrentPage = page;
      await this.loadBuildingData();
    },

    async jumpBuildingPage() {
      const page = parseInt(this.buildingPageInput);
      if (page >= 1 && page <= this.buildingTotalPages) {
        this.buildingCurrentPage = page;
        await this.loadBuildingData();
      }
      this.buildingPageInput = '';
    },

    // 房间管理相关方法
    showAddRoomModal() {
      this.isEditRoom = false;
      this.roomFormData = {
        room_number: '',
        room_type: '',
        capacity: '',
        current_occupancy: '',
        remark: '',
        dormitory: '',
        floor: ''
      };
      this.showRoomModal = true;
    },

    showEditRoomModal(item) {
      this.isEditRoom = true;
      this.roomFormData = {
        id: item.id || '',
        room_number: item.room_number || '',
        room_type: item.room_type || '',
        capacity: item.capacity || '',
        current_occupancy: item.current_occupancy,
        remark: item.remark || '',
        dormitory: item.dormitory || '',
        floor: item.floor || ''
      };
      this.showRoomModal = true;
    },

    closeRoomModal() {
      this.showRoomModal = false;
    },

    async saveRoomData() {
      try {
        if (this.isEditRoom) {
          // 编辑房间
          await this.editRoom();
        } else {
          // 新增房间
          await this.addRoom();
        }
        
        this.closeRoomModal();
        await this.loadRoomData(); // 重新加载数据
        alert(this.isEditRoom ? '编辑房间成功！' : '新增房间成功！');
      } catch (error) {
        console.error('保存房间数据失败:', error);
        alert('保存失败：' + error.message);
      }
    },

    // 新增房间
    async addRoom() {
      try {
        // 构建请求参数
        const requestData = {
          room_number: this.roomFormData.room_number,
          room_type: this.roomFormData.room_type,
          capacity: parseInt(this.roomFormData.capacity) || 0,
          current_occupancy: parseInt(this.roomFormData.current_occupancy) || 0,
          remark: this.roomFormData.remark,
          dormitory: parseInt(this.roomFormData.dormitory) || 0,
          floor: parseInt(this.roomFormData.floor) || 0
        };

        // 验证必填字段
        if (!requestData.room_number) {
          throw new Error('房间号不能为空');
        }
        if (!requestData.room_type) {
          throw new Error('房间类型不能为空');
        }
        if (!requestData.capacity || requestData.capacity <= 0) {
          throw new Error('床位数必须大于0');
        }
        if (!requestData.dormitory) {
          throw new Error('所属楼宇不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('新增房间成功！');
        } else {
          throw new Error(result.message || '新增失败');
        }
      } catch (error) {
        console.error('新增房间失败:', error);
        throw error;
      }
    },

    // 编辑房间
    async editRoom() {
      try {
        // 构建请求参数
        const requestData = {
          room_number: this.roomFormData.room_number,
          room_type: this.roomFormData.room_type,
          capacity: parseInt(this.roomFormData.capacity) || 0,
          current_occupancy: parseInt(this.roomFormData.current_occupancy) || 0,
          remark: this.roomFormData.remark,
          dormitory: parseInt(this.roomFormData.dormitory) || 0,
          floor: parseInt(this.roomFormData.floor) || 0,
        };

        // 验证必填字段
        if (!requestData.room_number) {
          throw new Error('房间号不能为空');
        }
        if (!requestData.room_type) {
          throw new Error('房间类型不能为空');
        }
        if (!requestData.capacity || requestData.capacity <= 0) {
          throw new Error('床位数必须大于0');
        }
        if (!requestData.dormitory) {
          throw new Error('所属楼宇不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/${this.roomFormData.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('编辑房间成功！');
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑房间失败:', error);
        throw error;
      }
    },

    async deleteRoom(item) {
      if (confirm(`确定要删除房间 ${item.room_number} 吗？`)) {
        try {
          // 调用删除房间接口
          await this.deleteRoomAPI(item.id);
          await this.loadRoomData(); // 重新加载数据
          alert('删除房间成功！');
        } catch (error) {
          console.error('删除房间失败:', error);
          alert('删除失败：' + error.message);
        }
      }
    },

    // 删除房间API调用
    async deleteRoomAPI(roomId) {
      try {
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/${roomId}/`, {
          method: 'DELETE',
          headers: this.getAuthHeaders()
        });

        if (response.ok) {
          return true;
        } else {
          const result = await response.json();
          throw new Error(result.message || '删除失败');
        }
      } catch (error) {
        console.error('删除房间API调用失败:', error);
        throw error;
      }
    },

    exportRoomData() {
      // TODO: 实现导出房间数据功能
      console.log('导出房间数据');
      alert('导出功能待实现');
    },

    // 房间管理分页相关方法
    async changeRoomPage(page) {
      this.roomCurrentPage = page;
      await this.loadRoomData();
    },

    async jumpRoomPage() {
      const page = parseInt(this.roomPageInput);
      if (page >= 1 && page <= this.roomTotalPages) {
        this.roomCurrentPage = page;
        await this.loadRoomData();
      }
      this.roomPageInput = '';
    },

    // 床位管理相关方法
    showAddBedModal() {
      this.isEditBed = false;
      this.bedFormData = {
        id: '',
        dormitory: '',
        dormitory_name: '',
        room: '',
        bed_number: '',
        status: 'vacant'
      };
      // 重置房间列表
      this.bedAvailableRooms = [];
      this.showBedModal = true;
    },

    showEditBedModal(item) {
      this.isEditBed = true;
      this.bedFormData = {
        id: item.id || '',
        dormitory: item.room_info?.dormitory_id || '',
        dormitory_name: item.room_info?.dormitory_name || '',
        room: item.id || '',
        bed_number: item.bed_number || '',
        status: item.personnel_info ? 'occupied' : 'occupied'
      };
      // 加载对应的房间列表
      if (this.bedFormData.dormitory_name) {
        this.loadBedAvailableRooms();
      }
      this.showBedModal = true;
    },

    closeBedModal() {
      this.showBedModal = false;
    },

    async saveBedData() {
      try {
        if (this.isEditBed) {
          // 编辑床位
          await this.editBed();
        } else {
          // 新增床位
          await this.addBed();
        }
        
        this.closeBedModal();
        await this.loadBedData(); // 重新加载数据
        alert(this.isEditBed ? '编辑床位成功！' : '新增床位成功！');
      } catch (error) {
        console.error('保存床位数据失败:', error);
        alert('保存失败：' + error.message);
      }
    },

    // 新增床位
    async addBed() {
      try {
        // 构建请求参数
        const requestData = {
          room: parseInt(this.bedFormData.room) || 0,
          bed_number: this.bedFormData.bed_number
        };

        // 验证必填字段
        if (!this.bedFormData.dormitory_name) {
          throw new Error('请选择宿舍楼');
        }
        if (!requestData.room) {
          throw new Error('请选择所属房间');
        }
        if (!requestData.bed_number) {
          throw new Error('床位号不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('新增床位成功！');
        } else {
          throw new Error(result.message || '新增失败');
        }
      } catch (error) {
        console.error('新增床位失败:', error);
        throw error;
      }
    },

    // 编辑床位
    async editBed() {
      try {
        // 构建请求参数
        const requestData = {
          room: parseInt(this.bedFormData.room) || 0,
          bed_number: this.bedFormData.bed_number
        };

        // 验证必填字段
        if (!this.bedFormData.dormitory_name) {
          throw new Error('请选择宿舍楼');
        }
        if (!requestData.room) {
          throw new Error('请选择所属房间');
        }
        if (!requestData.bed_number) {
          throw new Error('床位号不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/${this.bedFormData.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('编辑床位成功！');
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑床位失败:', error);
        throw error;
      }
    },

    async deleteBed(item) {
      if (confirm(`确定要删除床位 ${item.bed_number} 吗？`)) {
        try {
          // 调用删除床位接口
          await this.deleteBedAPI(item.id);
          await this.loadBedData(); // 重新加载数据
          alert('删除床位成功！');
        } catch (error) {
          console.error('删除床位失败:', error);
          alert('删除失败：' + error.message);
        }
      }
    },

    // 删除床位API调用
    async deleteBedAPI(bedId) {
      try {
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/${bedId}/`, {
          method: 'DELETE',
          headers: this.getAuthHeaders()
        });

        if (response.ok) {
          return true;
        } else {
          const result = await response.json();
          throw new Error(result.message || '删除失败');
        }
      } catch (error) {
        console.error('删除床位API调用失败:', error);
        throw error;
      }
    },

    exportBedData() {
      // TODO: 实现导出床位数据功能
      console.log('导出床位数据');
      alert('导出功能待实现');
    },

    // 床位管理分页相关方法
    async changeBedPage(page) {
      this.bedCurrentPage = page;
      await this.loadBedData();
    },

    async jumpBedPage() {
      const page = parseInt(this.bedPageInput);
      if (page >= 1 && page <= this.bedTotalPages) {
        this.bedCurrentPage = page;
        await this.loadBedData();
      }
      this.bedPageInput = '';
    },

    // 设备管理相关方法
    showAddDeviceModal() {
      this.isEditDevice = false;
      this.deviceFormData = {
        id: '',
        code: '',
        brand: '',
        model: '',
        status: '',
        access_type: '',
        dormitory: ''
      };
      this.showDeviceModal = true;
    },

    showEditDeviceModal(item) {
      this.isEditDevice = true;
      this.deviceFormData = {
        id: item.id || '',
        code: item.code || '',
        brand: item.brand || '',
        model: item.model || '',
        status: item.status || '',
        access_type: item.access_type || '',
        dormitory: item.dormitory || ''
      };
      this.showDeviceModal = true;
    },

    closeDeviceModal() {
      this.showDeviceModal = false;
    },

    async saveDeviceData() {
      try {
        if (this.isEditDevice) {
          // 编辑设备
          await this.editDevice();
        } else {
          // 新增设备
          await this.addDevice();
        }
        
        this.closeDeviceModal();
        await this.loadDeviceData(); // 重新加载数据
      } catch (error) {
        console.error('保存设备数据失败:', error);
        alert('保存失败：' + error.message);
      }
    },

    // 新增设备
    async addDevice() {
      try {
        // 构建请求参数
        const requestData = {
          code: this.deviceFormData.code,
          brand: this.deviceFormData.brand,
          model: this.deviceFormData.model,
          status: this.deviceFormData.status,
          access_type: this.deviceFormData.access_type,
          dormitory: parseInt(this.deviceFormData.dormitory) || 0
        };

        // 验证必填字段
        if (!requestData.code) {
          throw new Error('设备编号不能为空');
        }
        if (!requestData.brand) {
          throw new Error('设备品牌不能为空');
        }
        if (!requestData.model) {
          throw new Error('设备型号不能为空');
        }
        if (!requestData.status) {
          throw new Error('设备状态不能为空');
        }
        if (!requestData.access_type) {
          throw new Error('设备功能不能为空');
        }
        if (!requestData.dormitory) {
          throw new Error('所属楼栋不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/devices/`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('新增设备成功！');
        } else {
          throw new Error(result.message || '新增失败');
        }
      } catch (error) {
        console.error('新增设备失败:', error);
        throw error;
      }
    },

    // 编辑设备
    async editDevice() {
      try {
        // 构建请求参数
        const requestData = {
          code: this.deviceFormData.code,
          brand: this.deviceFormData.brand,
          model: this.deviceFormData.model,
          status: this.deviceFormData.status,
          access_type: this.deviceFormData.access_type,
          dormitory: parseInt(this.deviceFormData.dormitory) || 0
        };

        // 验证必填字段
        if (!requestData.code) {
          throw new Error('设备编号不能为空');
        }
        if (!requestData.brand) {
          throw new Error('设备品牌不能为空');
        }
        if (!requestData.model) {
          throw new Error('设备型号不能为空');
        }
        if (!requestData.status) {
          throw new Error('设备状态不能为空');
        }
        if (!requestData.access_type) {
          throw new Error('设备功能不能为空');
        }
        if (!requestData.dormitory) {
          throw new Error('所属楼栋不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/devices/${this.deviceFormData.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('编辑设备成功！');
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑设备失败:', error);
        throw error;
      }
    },

    async deleteDevice(item) {
      if (confirm(`确定要删除设备 ${item.code} 吗？`)) {
        try {
          // 调用删除设备接口
          await this.deleteDeviceAPI(item.id);
          await this.loadDeviceData(); // 重新加载数据
          alert('删除设备成功！');
        } catch (error) {
          console.error('删除设备失败:', error);
          alert('删除失败：' + error.message);
        }
      }
    },

    // 删除设备API调用
    async deleteDeviceAPI(deviceId) {
      try {
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/devices/${deviceId}/`, {
          method: 'DELETE',
          headers: this.getAuthHeaders()
        });

        if (response.ok) {
          return true;
        } else {
          const result = await response.json();
          throw new Error(result.message || '删除失败');
        }
      } catch (error) {
        console.error('删除设备API调用失败:', error);
        throw error;
      }
    },

    exportDeviceData() {
      // TODO: 实现导出设备数据功能
      console.log('导出设备数据');
      alert('导出功能待实现');
    },

    // 设备管理分页相关方法
    async changeDevicePage(page) {
      this.deviceCurrentPage = page;
      await this.loadDeviceData();
    },

    async jumpDevicePage() {
      const page = parseInt(this.devicePageInput);
      if (page >= 1 && page <= this.deviceTotalPages) {
        this.deviceCurrentPage = page;
        await this.loadDeviceData();
      }
      this.devicePageInput = '';
    },

    // 加载设备数据
    async loadDeviceData() {
      try {
        this.loading = true;
        
        // 构建查询参数
        const params = new URLSearchParams();
        if (this.deviceSearchForm.dormitory_name) {
          params.append('dormitory_name', this.deviceSearchForm.dormitory_name);
        }
        if (this.deviceSearchForm.room_number) {
          params.append('room_number', this.deviceSearchForm.room_number);
        }
        if (this.deviceSearchForm.bed_number) {
          params.append('bed_number', this.deviceSearchForm.bed_number);
        }
        if (this.deviceSearchForm.status) {
          params.append('status', this.deviceSearchForm.status);
        }
        params.append('page', this.deviceCurrentPage);
        params.append('page_size', this.devicePageSize);

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/devices/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          // 解析返回的数据结构
          this.deviceData = data.data.results || [];
          this.deviceTotalCount = data.data.count || 0;
          this.deviceTotalPages = Math.ceil(this.deviceTotalCount / this.devicePageSize);
        } else {
          console.error('获取设备数据失败:', data.message);
          this.deviceData = [];
          this.deviceTotalCount = 0;
          this.deviceTotalPages = 1;
        }
      } catch (error) {
        console.error('加载设备数据失败:', error);
        this.deviceData = [];
        this.deviceTotalCount = 0;
        this.deviceTotalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    // 加载宿管数据
    async loadManagerData() {
      try {
        this.loading = true;
        
        // 构建查询参数
        const params = new URLSearchParams();
        if (this.managerSearchForm.name) {
          params.append('name', this.managerSearchForm.name);
        }
        if (this.managerSearchForm.dormitory_name) {
          params.append('dormitory_name', this.managerSearchForm.dormitory_name);
        }
        params.append('page', this.managerCurrentPage);
        params.append('page_size', this.managerPageSize);

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/managers/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          // 解析返回的数据结构
          this.managerData = data.data.results || [];
          this.managerTotalCount = data.data.count || 0;
          this.managerTotalPages = Math.ceil(this.managerTotalCount / this.managerPageSize);
        } else {
          console.error('获取宿管数据失败:', data.message);
          this.managerData = [];
          this.managerTotalCount = 0;
          this.managerTotalPages = 1;
        }
      } catch (error) {
        console.error('加载宿管数据失败:', error);
        this.managerData = [];
        this.managerTotalCount = 0;
        this.managerTotalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    formatDateTime(now) {
      const padZero = n => n < 10 ? `0${n}` : n
      const year = now.getFullYear()
      const month = padZero(now.getMonth() + 1)
      const day = padZero(now.getDate())
      const formatDate = `${year}-${month}-${day}`
      return formatDate
    },
    
    async loadInoutData() {
      try {
        this.loading = true;
        const params = new URLSearchParams();
        params.append('page', this.inoutCurrentPage);
        params.append('page_size', this.inoutPageSize);
        const startDate = this.formatDateTime(this.inoutFormData.start_date);
        params.append('start_date', startDate);
        const endDate = this.formatDateTime(this.inoutFormData.end_date);
        params.append('end_date', endDate);
        if(this.inoutFormData.person_record__buildid > 0) {
          params.append('person_record__buildid', this.inoutFormData.person_record__buildid);
        }
        params.append('person_record__department', this.inoutFormData.person_record__department);
        params.append('access_type', this.inoutFormData.access_type);
        params.append('search', this.inoutFormData.search);
        for(let i = 0; i < this.inoutData.length; i++) {
          const item = this.inoutData[i];
          if(item.person_record.face_url != '') {
            URL.revokeObjectURL(item.person_record.face_url);
          }
        }
        this.inoutData = [];
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/personRecord/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });
        const data = await response.json();
        if (data) {
          // 解析返回的数据结构
          this.inoutData = data.results || [];
          this.inoutTotalCount = data.count || 0;
          this.inoutTotalPages = Math.ceil(this.inoutTotalCount / this.inoutPageSize);
          for (let i = 0; i < this.inoutData.length; i++) {
            const record = this.inoutData[i];
            record.record_time = record.record_time?.substr(0, 19) || '';
            record.person_record.face_url = this.base64ToImage(record.person_record.face_data);
          }
        } else {
          console.error('获取出入记录数据失败:', data.message);
          this.inoutData = [];
          this.inoutTotalCount = 0;
          this.inoutTotalPages = 1;
        }
      } catch (error) {
        console.error('加载出入记录数据失败:', error);
        this.inoutData = [];
        this.inoutTotalCount = 0;
        this.inoutTotalPages = 1;
      } finally {
        this.loading = false;
      }
    },

    showAddManagerModal() {
      this.isEditManager = false;
      this.managerFormData = {
        manager_id: '',
        name: '',
        gender: '',
        floor: '',
        managed_count: '',
        remark: '',
        dormitory: '',
        face_data: ''
      };
      this.showManagerModal = true;
    },

    showEditManagerModal(item) {
      this.isEditManager = true;
      this.managerFormData = {
        id: item.id || '',
        manager_id: item.manager_id || '',
        name: item.name || '',
        gender: item.gender || '',
        floor: item.floor || '',
        managed_count: item.managed_count || '',
        remark: item.remark || '',
        dormitory: item.dormitory || '',
        face_data: ''
      };
      this.showManagerModal = true;
    },

    closeManagerModal() {
      this.showManagerModal = false;
    },

    async saveManagerData() {
      try {
        if (this.isEditManager) {
          // 编辑宿管
          await this.editManager();
        } else {
          // 新增宿管
          await this.addManager();
        }
        
        this.closeManagerModal();
        await this.loadManagerData(); // 重新加载数据
        alert(this.isEditManager ? '编辑宿管成功！' : '新增宿管成功！');
      } catch (error) {
        console.error('保存宿管数据失败:', error);
        alert('保存失败：' + error.message);
      }
    },

    // 新增宿管
    async addManager() {
      try {
        // 构建请求参数
        const requestData = {
          manager_id: this.managerFormData.manager_id,
          name: this.managerFormData.name,
          gender: this.managerFormData.gender,
          floor: this.managerFormData.floor,
          managed_count: parseInt(this.managerFormData.managed_count) || 0,
          remark: this.managerFormData.remark,
          is_super: false, // 目前只添加普通管理员
          dormitory: parseInt(this.managerFormData.dormitory) || 0,
          face_data: this.managerFormData.face_data || ''
        };

        // 验证必填字段
        if (!requestData.manager_id) {
          throw new Error('宿管编号不能为空');
        }
        if (!requestData.name) {
          throw new Error('姓名不能为空');
        }
        if (!requestData.gender) {
          throw new Error('性别不能为空');
        }
        if (!requestData.floor) {
          throw new Error('管理楼层不能为空');
        }
        if (!requestData.managed_count || requestData.managed_count <= 0) {
          throw new Error('管理人数必须大于0');
        }
        if (!requestData.dormitory) {
          throw new Error('所属楼栋不能为空');
        }
        if (!requestData.face_data) {
          throw new Error('照片不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/managers/`, {
          method: 'POST',
          headers: this.getAuthHeaders(),
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('新增宿管成功！');
        } else {
          throw new Error(result.message || '新增失败');
        }
      } catch (error) {
        console.error('新增宿管失败:', error);
        throw error;
      }
    },

    // 编辑宿管
    async editManager() {
      try {
        // 构建请求参数
        const requestData = {
          floor: this.managerFormData.floor,
          gender: this.managerFormData.gender,
          managed_count: parseInt(this.managerFormData.managed_count) || 0,
          remark: this.managerFormData.remark,
          dormitory: parseInt(this.managerFormData.dormitory) || 0
        };

        // 验证必填字段
        if (!requestData.floor) {
          throw new Error('管理楼层不能为空');
        }
        if (!requestData.gender) {
          throw new Error('性别不能为空');
        }
        if (!requestData.managed_count || requestData.managed_count <= 0) {
          throw new Error('管理人数必须大于0');
        }
        if (!requestData.dormitory) {
          throw new Error('所属楼栋不能为空');
        }

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/managers/${this.managerFormData.id}/`, {
          method: 'PATCH',
          headers: {
            'Content-Type': 'application/json',
            ...this.getAuthHeaders()
          },
          body: JSON.stringify(requestData)
        });

        const result = await response.json();
        
        if (result.code === 200) {
          alert('编辑宿管成功！');
        } else {
          throw new Error(result.message || '编辑失败');
        }
      } catch (error) {
        console.error('编辑宿管失败:', error);
        throw error;
      }
    },

    async deleteManager(item) {
      if (confirm(`确定要删除宿管 ${item.name} 吗？`)) {
        try {
          // 调用删除宿管接口
          await this.deleteManagerAPI(item.id);
          await this.loadManagerData(); // 重新加载数据
          alert('删除宿管成功！');
        } catch (error) {
          console.error('删除宿管失败:', error);
          alert('删除失败：' + error.message);
        }
      }
    },

    // 删除宿管API调用
    async deleteManagerAPI(managerId) {
      try {
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/managers/${managerId}/`, {
          method: 'DELETE',
          headers: this.getAuthHeaders()
        });

        if (response.ok) {
          return true;
        } else {
          const result = await response.json();
          throw new Error(result.message || '删除失败');
        }
      } catch (error) {
        console.error('删除宿管API调用失败:', error);
        throw error;
      }
    },

    exportManagerData() {
      // TODO: 实现导出宿管数据功能
      console.log('导出宿管数据');
      alert('导出功能待实现');
    },

    // 宿管管理分页相关方法
    async changeManagerPage(page) {
      this.managerCurrentPage = page;
      await this.loadManagerData();
    },

    async jumpManagerPage() {
      const page = parseInt(this.managerPageInput);
      if (page >= 1 && page <= this.managerTotalPages) {
        this.managerCurrentPage = page;
        await this.loadManagerData();
      }
      this.managerPageInput = '';
    },

    async changeInoutPage(page) {
      this.inoutCurrentPage = page;
      await this.loadInoutData();
    },
    async jumpInoutPage() {
      const page = parseInt(this.inoutPageInput);
      if (page >= 1 && page <= this.inoutTotalPages) {
        this.inoutCurrentPage = page;
        await this.loadInoutData();
      }
      this.inoutPageInput = '';
    },

    handleManagerImageUpload(event) {
      const file = event.target.files[0];
      if (file) {
        const reader = new FileReader();
        reader.onload = (e) => {
          // 获取Base64数据，去掉data:image/jpeg;base64,前缀
          const base64Data = e.target.result.split(',')[1];
          this.managerFormData.face_data = base64Data;
        };
        reader.readAsDataURL(file);
      }
    },

    // 添加获取楼宇选项的方法
    async loadDormitoryOptions() {
      try {
        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/hostels/?page_size=1000`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.dormitoryOptions = (data.data.results || []).map(item => ({
            value: item.name,
            label: item.name
          }));
        } else {
          console.error('获取楼宇选项失败:', data.message);
          this.dormitoryOptions = [];
        }
      } catch (error) {
        console.error('加载楼宇选项失败:', error);
        this.dormitoryOptions = [];
      }
    },

    // 编辑模式：宿舍楼选择变化时，加载对应的房间列表
    async loadEditAvailableRooms() {
      try {
        const params = new URLSearchParams();
        if (this.formData.dormitory_name) {
          params.append('dormitory_name', this.formData.dormitory_name);
        }
        params.append('page_size', 100); // 获取更多房间数据

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/rooms/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.editAvailableRooms = data.data.results || [];
        } else {
          console.error('获取编辑房间列表失败:', data.message);
          this.editAvailableRooms = [];
        }
      } catch (error) {
        console.error('加载编辑房间列表失败:', error);
        this.editAvailableRooms = [];
      }
    },

    // 编辑模式：宿舍楼选择变化时，加载对应的房间列表
    async onEditDormitoryChange() {
      this.formData.room_number = '';
      this.formData.bed_number = '';
      this.editAvailableRooms = [];
      this.editAvailableBeds = [];
      
      if (this.formData.dormitory_name) {
        await this.loadEditAvailableRooms();
      }
    },

    // 编辑模式：房间选择变化时，加载对应的床位列表
    async onEditRoomChange() {
      this.formData.bed_number = null;
      this.editAvailableBeds = [];
      
      if (this.formData.room_number) {
        await this.loadEditAvailableBeds();
      }
    },



    // 编辑模式：获取可用的床位列表
    async loadEditAvailableBeds() {
      try {
        const params = new URLSearchParams();
        if (this.formData.dormitory_name) {
          params.append('dormitory_name', this.formData.dormitory_name);
        }
        if (this.formData.room_number) {
          params.append('room_number', this.formData.room_number);
        }
        params.append('is_empty', 'true'); // 只获取空闲的床位
        params.append('page_size', 100);

        const response = await fetch(`${HTTP_CONFIG.SERVER_ADDR}/beds/?${params.toString()}`, {
          method: 'GET',
          headers: this.getAuthHeaders()
        });

        const data = await response.json();
        
        if (data.code === 200 && data.data) {
          this.editAvailableBeds = data.data.results || [];
        } else {
          console.error('获取编辑床位列表失败:', data.message);
          this.editAvailableBeds = [];
        }
      } catch (error) {
        console.error('加载编辑床位列表失败:', error);
        this.editAvailableBeds = [];
      }
    }
  },
  mounted() {
    // 初始化加载数据
    this.loadPersonnelData();
    this.loadBuildingData(); // 加载楼宇列表用于新增房间
    this.loadRoomData(); // 加载房间列表用于新增床位
    this.loadDeviceData(); // 加载设备数据
    this.loadManagerData(); // 加载宿管数据
    this.loadDormitoryOptions(); // 加载楼宇选项用于搜索
  }
}
</script>

<style scoped>
/* 状态样式 */
.status-in {
  color: #4caf50;
  font-weight: bold;
}

.status-out {
  color: #f44336;
  font-weight: bold;
}

.status-occupied {
  color: #f44336;
  font-weight: bold;
}

.status-vacant {
  color: #4caf50;
  font-weight: bold;
}

.status-online {
  color: #4caf50;
  font-weight: bold;
}

.status-offline {
  color: #f44336;
  font-weight: bold;
}

/* 弹窗样式 */
.modal-mask {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  background: #0003;
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.modal-content {
  background: #fff;
  padding: 40px 60px 32px 60px;
  border-radius: 8px;
  min-width: 700px;
  position: relative;
}

/* 新增蓝色按钮样式 */
.search-btn-blue {
  background: #2196f3;
  color: white;
  border: none;
  padding: 8px 16px;
  border-radius: 4px;
  cursor: pointer;
  font-size: 14px;
}

.search-btn-blue:hover {
  background: #1976d2;
}

/* 重置按钮样式 */
.search-btn-green[style*="background: #ff9800"] {
  background: #ff9800 !important;
  color: white;
}

.search-btn-green[style*="background: #ff9800"]:hover {
  background: #f57c00 !important;
}
</style> 